/*
* @Des 组件 实时定位
* @Description
* @Author 
* @Date 2021/8/6
*/
/* HTML */
<template>
	<div :class="{'_table-item-box view-page-box padding-l-none': true, 'max-box': !showTreeBoxFlag}">
		<section style="height: 100%;">
			 
			<!-- 主内容 start -->
			<div :class="{'page-box': true, 'no-items': maps.length <= 0 || hideItemsFlag || (this.$checkEmpty(users) && this.$checkEmpty(cars) && this.$checkEmpty(tools))}">
			 	
			 	<!-- 地图 容器 -->
			 	<div class="map-box">
			 		<SubRaphaelMap ref="svgMap" :class="{'off': mapsUrlEmpty}" :mapEleId="'svg_map_fence'" />
			 		<div :class="{'none-map-item': true, 'off': !mapsUrlEmpty}" >
			 			<img alt="加载中" v-show="orgLoadingFlag" title="加载中" src="@/static_dazzle/images/loading_1.gif" >
			 			<img alt="暂无地图" v-show="!orgLoadingFlag" title="暂无地图" src="@/static_dazzle/images/map_none.png" >
			 		</div>
			 	</div>
			 	
			 	<!-- 数据列表 start -->
			 	<div :class="{'items-box': true, 'is-track-on': map_list_trackPeo.size() > 0}" >
			 		<!-- 自定义折叠面板 list -->
			 		<div :class="{'fold-item-list': true, 'fold-list-mini': foldMIniFlag}">
			 			
			 			<!-- 自定义折叠面板 item box -->
			 			<div :class="{'fold-item-box': true, 'is-active': foldValue == 'user'}">
			 				<!-- 标题 start -->
			 				<div class="fold-item-title">
			 					<span class="cursor-pointer" @click="toggleFold('user')" style="white-space: nowrap;">人员列表</span>
			 					
			 					<!-- 条件查询 start -->
			 					<el-form :inline="true" :model="userFilters" ref="userFilters" class="row-item-filter">
									<el-form-item prop="groupId">
										<TreeSelect :data="userGroups" :selectTree="uGroupSelectTree" @setSelectVal="setSelectVal_u" ref="userTreeSelect" :width="'110px'"/>
									</el-form-item>
									<el-form-item prop="keyword">
										<el-input style="width: 150px;" v-model="userFilters.keyword" placeholder="姓名/拼音/编号/标签号" clearable @input.native="filterUsers" @clear="filterUsers">
											<i slot="suffix" class="el-input__icon el-icon-search" @click="filterUsers"></i>
										</el-input>
									</el-form-item>
								</el-form>
								<!-- 条件查询 end -->
								
			 					<b class="header-icon _el-icon-info collapse-item__header_info cursor-pointer" :title="[('总数：' + users.length), ('报警数：' + alarmNum_user)].join('\n')" @click="toggleFold('user')"><font color="#f91d1d">{{alarmNum_user}}</font>&nbsp;/&nbsp;{{users.length}}</b>
			 					<i class="el-icon-arrow-right fold-item-title-icon cursor-pointer" @click="toggleFold('user')"></i>
			 				</div>
			 				<!-- 标题 end -->
			 				<!-- 内容 start -->
			 				<div class="fold-item-wrap">
			 					
			 					<!-- el-row start -->
			 					<!--<el-row :gutter="0" v-for="(item, index) in userList" :key="index" v-show="!(
			 						(!$checkEmpty(userFilters.typeId) && String(userFilters.typeId) != String(item.userData.typeId)) ||
			 						(!$checkEmpty(userFilters.groupId) && String(userFilters.groupId) != String(item.userData.groupId)) ||
			 						(!$checkEmpty(userFilters.keyword) && (item.userData.userName.indexOf(userFilters.keyword) == -1 && item.userData.userNamePy.toUpperCase().indexOf(userFilters.keyword.toUpperCase()) == -1 && item.userData.userNo.indexOf(userFilters.keyword.toUpperCase()) == -1 && item.userData.tagId.indexOf(userFilters.keyword.toUpperCase()) == -1 ))
			 					)">-->
			 					<el-row :gutter="0" v-for="(item, index) in userList" :key="index" >
					                <!-- el-col start -->
					                <el-col :span="24" :class="{'alarm': (!$checkEmpty(item.alarmData) && !$checkEmpty(item.alarmData.list))}">
					                	<div :class="'grid-content ' + ('icon-user-bg-' + (item.userData.carType ? '100' : item.userData.typeId))">
					                		<div class="collapse-item-content" style="position: absolute;z-index: 1;">
			                					<p style="padding: 0;line-height: 26px;" :title="[('分组：' + ($checkEmpty(item.userData.groupName) ? '----': item.userData.groupName)), ((item.userData.carType ? '车牌号：' : '名称：') + (item.userData.carType ?  item.userData.carNumber : item.userData.userName))].join('\n')">
			                						{{($checkEmpty(item.userData.groupName) ? '' : (item.userData.groupName))}}
			                						<br v-if="!$checkEmpty(item.userData.groupName)">
			                						<span style="line-height: 30px;font-size: 24px;">{{item.userData.carType ?  item.userData.carNumber : item.userData.userName}}</span>
			                						<span v-if="item.userData.sex == 1" class="el-icon-male" style="padding-left: 5px;color: #45da14;line-height: 26px;"></span>
			                						<span v-if="item.userData.sex == 2" class="el-icon-female" style="padding-left: 5px;color: #f7786b;line-height: 26px;"></span>
			                						<br v-if="!$checkEmpty(item.alarmData) && !$checkEmpty(item.alarmData.list)" />
			                						<span v-if="!$checkEmpty(item.alarmData) && !$checkEmpty(item.alarmData.list)" style="line-height: 30px;color: #fff;">{{extractUpdateTime(item.tagId)}}</span>
			                					</p>
			                					
			                				</div>
			                				<template>
			                					<div v-if="!$checkEmpty(item.alarmData) && !$checkEmpty(item.alarmData.list)" :title="calAlarmsTit(item.alarmData)" style="min-height: 160px;">
						                			<div class="collapse-item-content" v-for="(row, index) in (item.alarmData.list)" :key="index">
					                					<div class="item-content-tit">{{$moment(row.time).format('YYYY-MM-DD HH:mm:ss')}}</div>
					                					<div class="item-content-cont red-color">{{row.alarmName}}</div>
					                					<!--<div>{{item.alarmData.formatRow.alarmNames.join(';&nbsp;')}}</div>-->
					                				</div>
						                		</div>
						                		<div v-else title="正常作业" style="min-height: 130px;">
						                			<div class="collapse-item-content">
					                					<div class="item-content-tit">{{extractUpdateTime(item.tagId)}}</div>
					                					<div class="item-content-cont">正常作业</div>
					                					<!--<div>{{item.alarmData.formatRow.alarmNames.join(';&nbsp;')}}</div>-->
					                				</div>
						                		</div>
			                				</template>
			                				
			                				<div class="item-btns-box track-btns-box" >
						                    	<i v-show="trackedIds.indexOf(item.tagId) > -1" class="el-icon-position track-item-on-btn" title="取消追踪" @click="trackPeo(item.tagId, false)">取消追踪</i>
						                    	<i v-show="trackedIds.indexOf(item.tagId) == -1" class="el-icon-s-promotion track-item-btn" title="开始追踪" @click="trackPeo(item.tagId, true)">开始追踪</i>
						                    </div>
			                				
					                	</div>
					                </el-col>
					                <!-- el-col end -->
					            </el-row>
					            <!-- el-row end -->
								
								<infinite-loading :identifier="infiniteId" @infinite="infiniteHandler" :distance="30" spinner="bubbles">
									<span slot="no-more">数据已全部加载 （＾∀＾）</span>
									<span slot="no-results">暂无数据 :(</span>
								</infinite-loading>
			 					
			 				</div>
			 				<!-- 内容 end -->
			 			</div>
			 			<!-- 自定义折叠面板  item box -->
			 			
			 		</div>
			 		<!-- 自定义折叠面板 list -->
			 	</div>
			 	<!-- 数据列表 start -->
			 	
			 	<!-- 追踪人员详情 start -->
			 	<div :class="{'detail-track-item': true, 'detail-has-portrait': ((trackedRows[0].userData.portrait!=null&&trackedRows[0].userData.portrait!='') || trackedRows[0].userData.carType)}" v-if="!$checkEmpty(trackedRows) && !hideItemsFlag">
			 		
			 		<!-- 工具 -->
			 		<template v-if="trackedRows[0].userData.toolType == 10">
			 			<div class="collapse-item-content">
	    					<span>工具名称：</span>
	    					<p :title="trackedRows[0].userData.toolName">{{$checkEmpty(trackedRows[0].userData.toolName) ? '----' : trackedRows[0].userData.toolName}}</p>
	    				</div>
	    				<div class="collapse-item-content">
	    					<span>工具编号：</span>
	    					<p :title="trackedRows[0].userData.toolNum">{{$checkEmpty(trackedRows[0].userData.toolNum) ? '----' : trackedRows[0].userData.toolNum}}</p>
	    				</div>
	    				<div class="collapse-item-content">
	    					<span>工具分组：</span>
	    					<p :title="trackedRows[0].userData.groupName">{{$checkEmpty(trackedRows[0].userData.groupName) ? '----' : trackedRows[0].userData.groupName}}</p>
	    				</div>
			 		</template>
			 		<!-- 人员 -->
			 		<template v-else>
			 			<div v-if="(trackedRows[0].userData.portrait!=null&&trackedRows[0].userData.portrait!='') || trackedRows[0].userData.carType" style="padding-top: 4px;z-index: 1;line-height: 0;height: 154px;position: absolute;left: 20px;top: 0px;bottom: 0;margin: auto;">
			 				<!--<el-image v-if="trackedRows[0].userData.carType" style="width: 120px;height: 150px;border-radius: 4px;background-color: rgba(255, 255, 255, 0.9);border: 2px solid #018df2;" :src="HookImg" :fit="'contain'"></el-image>-->
			 				<el-image v-if="trackedRows[0].userData.carType" style="width: 120px;height: 150px;border-radius: 4px;background-color: rgba(255, 255, 255, 0.9);border: 2px solid #018df2;" :src="CarImg" :fit="'contain'"></el-image>
			 				<el-image v-else style="width: 120px;height: 150px;border-radius: 4px;background-color: rgba(255, 255, 255, 0.9);border: 2px solid #018df2;" :src="trackedRows[0].userData.portrait" :fit="'contain'"></el-image>
			 			</div>
			 			<div class="collapse-item-content">
	    					<span>{{trackedRows[0].userData.carType ? '车牌号：' : '名称：'}}</span>
	    					<p :title="trackedRows[0].userData.userName">
	    						{{trackedRows[0].userData.carType ? ($checkEmpty(trackedRows[0].userData.carNumber) ? '----' : trackedRows[0].userData.carNumber) : ($checkEmpty(trackedRows[0].userData.userName) ? '----' : trackedRows[0].userData.userName)}}
	    						<span v-if="trackedRows[0].userData.sex == 1" class="el-icon-male" style="padding-left: 5px;color: #45da14;line-height: 30px;"></span>
	    						<span v-if="trackedRows[0].userData.sex == 2" class="el-icon-female" style="padding-left: 5px;color: #f7786b;line-height: 30px;"></span>
	    					</p>
	    				</div>
	    				<div class="collapse-item-content" v-if="false">
	    					<span>人员编号：</span>
	    					<p :title="trackedRows[0].userData.userNo">{{$checkEmpty(trackedRows[0].userData.userNo) ? '----' : trackedRows[0].userData.userNo}}</p>
	    				</div>
	    				<div class="collapse-item-content">
	    					<span>分组：</span>
	    					<p :title="trackedRows[0].userData.groupName">{{$checkEmpty(trackedRows[0].userData.groupName) ? '----' : trackedRows[0].userData.groupName}}</p>
	    				</div>
			 		</template>
    				
    				<div class="collapse-item-content">
    					<span>绑定设备：</span>
    					<p :title="trackedRows[0].userData.tagId">{{trackedRows[0].userData.tagId}}</p>
    				</div>
    				
    				<div v-if="false && !$checkEmpty(trackedRows[0].posiData)" class="collapse-item-content">
    					<span>距离起始点：</span>
    					<p :title="Math.abs(trackedRows[0].posiData.pointX - trackedRows[0].mapData.startPointX).toFixed(3) + ' 米'">{{Math.abs(trackedRows[0].posiData.pointX - trackedRows[0].mapData.startPointX).toFixed(3)}}&nbsp;米</p>
    				</div>
    				<div v-if="!$checkEmpty(trackedRows[0].posiData)" class="collapse-item-content">
    					<span>位置坐标&nbsp;(米)：</span>
    					<p :title="[trackedRows[0].posiData.pointX, trackedRows[0].posiData.pointY].join(',')">{{[trackedRows[0].posiData.pointX, trackedRows[0].posiData.pointY].join(',')}}</p>
    				</div>
    				<div v-if="!$checkEmpty(trackedRows[0].posiData)" class="collapse-item-content">
    					<span>高&nbsp;&nbsp;度&nbsp;(米)：</span>
    					<p :title="trackedRows[0].posiData.pointZ + ' 米'">{{trackedRows[0].posiData.pointZ + ' 米'}}</p>
    				</div>
    				
    				<div v-if="false && !$checkEmpty(trackedRows[0].posiData)" class="collapse-item-content">
    					<span>高&ensp;&ensp;度：</span>
    					<p :title="(trackedRows[0].posiData.pointZ).toFixed(3) + '米'">{{(trackedRows[0].posiData.pointZ).toFixed(3)}}&nbsp;米</p>
    				</div>
    				<div class="collapse-item-content">
    					<span>位置更新时间：</span>
    					<p :title="($checkEmpty(trackedRows[0].posiData.time) ? '----' : $moment(trackedRows[0].posiData.time).format('YYYY-MM-DD HH:mm:ss'))">{{$checkEmpty(trackedRows[0].posiData.time) ? '----' : $moment(trackedRows[0].posiData.time).format('YYYY-MM-DD HH:mm:ss')}}</p>
    				</div>
            		
            		<div v-if="!$checkEmpty(trackedRows[0].alarmData) && !$checkEmpty(trackedRows[0].alarmData.list)" :title="calAlarmsTit(trackedRows[0].alarmData)">
        				<div class="collapse-item-content" v-for="(r, i) in trackedRows[0].alarmData.list" :key="r.id">
        					<span>{{r.alarmName}}时间：</span>
    					<p :title="($checkEmpty(r.time) ? '----' : $moment(r.time).format('YYYY-MM-DD HH:mm:ss'))">{{$checkEmpty(r.time) ? '----' : $moment(r.time).format('YYYY-MM-DD HH:mm:ss')}}</p>
        				</div>
            		</div>
			 	</div>
			 	<!-- 追踪人员详情 start -->
			 	
			 	<!-- 人员信息 star 点名 -->
			    <el-collapse-transition>
				    <div class="list-box-rollCall" v-if="rollCallFilters.infoFlag">
				        <div class="quick-search" style="border-color: rgba(0,0,0,0);">
				            <span v-if="false" :class="{'search-text': true, 'on': rollCallFilters.onKey == 'polices'}" @click="changeRollCallTab('polices')" style="height: 24px;line-height: 24px;">
				            	干警人数：<span >{{rollCallFilters.polices.length}}</span>
				            </span>
				            <span :class="{'search-text': true, 'on': rollCallFilters.onKey == 'prisoners'}" typekey="userList" @click="changeRollCallTab('prisoners')" style="height: 24px;line-height: 24px;">
				            	学员人数：<span >{{rollCallFilters.prisoners.length}}</span>
				            </span>
				            <span v-if="false" :class="{'search-text': true, 'on': rollCallFilters.onKey == 'tools'}" typekey="carList" @click="changeRollCallTab('tools')" style="height: 24px;line-height: 24px;">
				            	工具个数：<span >{{rollCallFilters.tools.length}}</span>
				            </span>
				        </div>
				        <span class="quick-close" @click="closeRollCallInfo()"><i class="iconfont el-icon-my_guanbi
	"></i></span>
				        <div class="clearfix"></div>
				        <div class="tab-tit">
				            <ul style="width: 480px;">
				                <li>名称</li>
				                <li>编号</li>
				                <li style="width: 120px;">状态</li>
				            </ul>
				        </div>
				        
				        <!-- list tbody start -->
				        <div class="tab-cont">
				            
				            <!-- item tr start -->
				            <div class="tab-row1" v-for="(item, index) in rollCallFilters.onRows" :key="index">
				                <ul style="width: 480px;">
				                    <li>{{item.name}}</li>
				                    <li>{{item.userNo}}</li>
				                    <li style="width: 120px;">{{item.isAlarmed == 0 ? '定位' : '报警'}}</li>
				                </ul>
				            </div>
				            <!-- item tr end -->
				            
				            <div v-if="$checkEmpty(rollCallFilters.onRows)" style="height: 60px;line-height: 60px;text-align: center;font-size: 18px;">暂无数据</div>
				            
				        </div>
				        <!-- list tbody end -->
				        
				    </div>
			    </el-collapse-transition>
			    <!-- 人员信息 end 点名 -->
			 	
			 	<!-- 区域列表 start -->
			 	<div :class="{'area-items-box': true, 'roll-call-on': handleFilters.rollCallFlag}" v-show="false && areas.length > 0">
			 		<ul>
			 			<li v-for="(item, index) in areas" 
			 				:key="index" 
			 				:class="{'on': item.areaId == filters.areaId}" 
			 				:title="item.label"
			 				@click="clickAreaRow(item)">{{item.label}}</li>
			 			<li v-if="this.$checkEmpty(areas)" title="暂无区域">暂无区域</li>
			 		</ul>
			 	</div>
			 	<!-- 区域列表 end -->
			 	
			 	<!-- 地图列表 start -->
			 	<div :class="{'map-items-box': true, 'roll-call-on': handleFilters.rollCallFlag}" v-show="false && !mapsUrlEmpty">
			 		<ul>
			 			<li v-show="!areaUrlEmpty" 
			 				:class="{'on': $checkEmpty(filters.mapId)}" 
			 				@click="clickShowAreaMap()" 
			 				title="总览图">总览图</li>
			 			<li v-for="(item, index) in maps" 
			 				:key="index" 
			 				:class="{'on': item.mapId == filters.mapId}" 
			 				:title="item.mapName"
			 				@click="clickMapRow(item)">{{item.mapName}}</li>
			 			<li v-if="this.$checkEmpty(maps) && false" title="暂无地图">暂无地图</li>
			 		</ul>
			 	</div>
			 	<!-- 区域列表 end -->
			 	
			 	<!-- 操作按钮 start -->
			 	<div class="handle-btns-box">
					<el-button 
						v-if="checkTunnelAppFlag()" 
			 			type="primary" :class="{'on': handleFilters.showMileageFlag}" icon="iconfont el-icon-my_flag-full" size="mini" trigger="click" @click="toggleMileageFlag()" title="显示/隐藏 里程" v-show="maps.length > 0" ></el-button>
			 		
			 		<el-button type="primary" :class="{'on': handleFilters.showBsFlag}" icon="iconfont el-icon-my_base-signal-full" size="mini" trigger="click" @click="toggleBsFlag()" title="显示/隐藏 基站" v-show="maps.length > 0" ></el-button>
			 		
			 		<!--  下拉菜单-->
					<el-dropdown v-if="maps.length > 0" @command="handleCommand_eFence" trigger="click" class="handle-btns-dropdown">
						<!--  绑定指令,在methods里定义-->
						<span class="el-dropdown-link mine-btn">
							<el-button v-if="!$checkEmpty(eFenceFilters.eType) && !$checkEmpty(eFenceFilters.label)" type="primary" class="on" icon="iconfont el-icon-my_dianziweilan" size="mini" trigger="click" title="显示/隐藏 电子围栏" >{{eFenceFilters.label}}</el-button>
							<el-button v-else type="primary" class="" icon="iconfont el-icon-my_dianziweilan" size="mini" trigger="click" title="显示/隐藏 电子围栏" v-show="maps.length > 0" ></el-button>
						</span>
						<el-dropdown-menu slot="dropdown" class="handle-btns-dropdown-menu">
							<el-dropdown-item :command="{val: null, label: ''}">不再显示</el-dropdown-item>
							<!-- icon是修改图标 ，command是点击后传给方法的值-->
							<template v-for="(item, index) in eFenceFilters.eTypes">
								<el-dropdown-item v-if="eFenceFilters.eType != item.val" :command="item">{{item.label}}</el-dropdown-item>
							</template>
						</el-dropdown-menu>
					</el-dropdown>
					<!--  下拉菜单结束-->
			 		
			 		<!--  下拉菜单-->
					<el-dropdown v-if="maps.length > 1" @command="handleCommand_map" trigger="click" class="handle-btns-dropdown">
						<!--  绑定指令,在methods里定义-->
						<span class="el-dropdown-link mine-btn">
							<el-button type="primary" class="on" size="mini" trigger="click" title="" v-show="maps.length > 0 && !$checkEmpty(filters.mapId)" >{{$checkEmpty(map_list_maps.get(filters.mapId)) || $checkEmpty(map_list_maps.get(filters.mapId).mapName) ? '--' : map_list_maps.get(filters.mapId).mapName}}</el-button>
						</span>
						<el-dropdown-menu slot="dropdown" class="handle-btns-dropdown-menu">
							<!-- icon是修改图标 ，command是点击后传给方法的值-->
							<template v-for="(item, index) in maps">
								<el-dropdown-item v-if="filters.mapId != item.mapId" :command="item">{{item.mapName}}</el-dropdown-item>
							</template>
						</el-dropdown-menu>
					</el-dropdown>
					<!--  下拉菜单结束-->
					
					<el-button v-if="maps.length == 1" type="primary" class="on" size="mini" trigger="click" title="" v-show="maps.length > 0 && !$checkEmpty(filters.mapId)" >{{$checkEmpty(map_list_maps.get(filters.mapId)) || $checkEmpty(map_list_maps.get(filters.mapId).mapName) ? '--' : map_list_maps.get(filters.mapId).mapName}}</el-button>
					
					<el-button v-if="showIntoRealFlag" type="primary" :class="{'on': true}" icon="iconfont el-icon-my_fenxiang" size="mini" trigger="click" @click="toggleIntoReal()" title="实时监控" ></el-button>
					
			 		<el-button v-if="false" type="primary" :class="{'on': handleFilters.showTkFlag}" icon="iconfont el-icon-my_tubiao-yigui" size="mini" trigger="click" @click="toggleTkFlag()" title="显示/隐藏 工具柜" v-show="maps.length > 0" ></el-button>
					
					<el-button v-if="false" type="primary" :class="{'on': handleFilters.rollCallFlag}" icon="iconfont el-icon-my_dianmingceshi" size="mini" trigger="click" @click="toggleRollCall()" title="开始/结束 点名" v-show="maps.length > 0" ></el-button>
					
			 	</div>
			 	<!-- 操作按钮 start -->
			 	
			</div>
			<!-- 主内容 end -->
			
			<!-- webSoket jkkcPlayer -->
			<SubJkkcPlayer ref="wsPlayer" v-if="!disallowVideoFlag && videoPlayerMode == 1 && screenMode != 0 && wsPlayerFilter.creatWsFlag"
				:wsOnopen="wsPlayerFilter.wsOnopen"
				:wsOnmessage="wsPlayerFilter.wsOnmessage"
			/>
			
		</section>
	</div>
</template>

/* JS */
<script>
	// 公共变量
	import GlobalVariable from '@/global/global-variable';
    // 公共方法
    import GlobalFun from '@/global/global-function';
    import Secret from "@/secret";
    
    // API 组织结构
    import ApiOam from "@/request/api-oam";
    // API 围栏信息
    import ApiFence from '@/request/api-fence';
    // API 摄像头信息
    import ApiVideo from '@/request/api-video';
    // API 人员信息
    import ApiUser from "@/request/api-user";
	
    // svg地图 组件
    import SubRaphaelMap from '@/components/SubRaphaelMap';
	// jkkcPlayer 组件
	import SubJkkcPlayer from '@/components/SubJkkcPlayer';
	// 组件 下拉树结构
	import TreeSelect from '@/components/TreeSingleSelect';
	// 组件 上拉加载
	import InfiniteLoading from 'vue-infinite-loading';
	
	// img 天车吊钩
	import HookImg from '@/static_dazzle/images/bgs/hook.png';
	import CarImg from '@/static_dazzle/images/bgs/car.png';
	
	export default {
        name: "InTimePosition",
        /**
         * @Des 组件名
         * @Auth
         * @Date 2021/8/6
         */
        props: {
            /**
             * @Des 展示box
             * @Auth
             * @Date 2021/8/6
             */
            showTreeBoxFlag: {
                type: Boolean,
                default: function (){
                    return true;
                }
            },
            /**
             * @Des 隐藏 列表
             * @Auth
             * @Date 
             */
            hideItemsFlag: {
                type: Boolean,
                default: function (){
                    return false;
                }
            },
            /**
             * @Des 隐藏 里程
             * @Auth
             * @Date 
             */
            hideMileageFlag: {
                type: Boolean,
                default: function (){
                    return false;
                }
            },
            /**
             * @Des 隐藏 基站
             * @Auth
             * @Date 
             */
            hideBsFlag: {
                type: Boolean,
                default: function (){
                    return false;
                }
            },
            /**
             * @Des 隐藏 电子围栏
             * @Auth
             * @Date 
             */
            hideFenceFlag: {
                type: Boolean,
                default: function (){
                    return false;
                }
            },
            /**
             * @Des 禁止 视频
             * @Auth
             * @Date 
             */
            disallowVideoFlag: {
                type: Boolean,
                default: function (){
                    return false;
                }
            },
			/**
			 * @Des 展示 进入实时页面
			 * @Auth
			 * @Date
			 */
			showIntoRealFlag: {
				type: Boolean,
				default: function (){
					return false;
				}
			},
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/8/6
         */
        components: {
            // svg地图 组件
            SubRaphaelMap,
            // jkkcPlayer 组件
            SubJkkcPlayer,
            // 组件 下拉树结构
            TreeSelect,
            // 组件 上拉加载
            InfiniteLoading,
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/8/6
         */
        data() {
            return {
                // 折叠面板
                foldValue: 'user',
                // 折叠面板 mini
                foldMIniFlag: false,
                // 计时器 fold mini
                timer_fold_mini: null,
                
                /**
	             * @Des filters
	             * @Auth
	             * @Date 2021/8/6
	             */
                filters: {
                    areaId: '',
                    mapId: '',
                    trackedOne: false,
                },
                // svg elem
                mapSub: this.$refs.svgMap,
				
				// 加载 组织结构 flag
				orgLoadingFlag: true,
				// 组织结构 list
				orgList: [],
				// 地图 总list
				orgMaps: [],
                // 区域
                areas: [],
                // 地图
                maps: [],
				// 缓存  记录 区域信息
				map_list_areas: new this.HashMap(),
				// 缓存  记录 地图信息
				map_list_maps: new this.HashMap(),
				// 报警类型
				alarmStates: {},
				// 报警类型
				alarmStateSwitchs: {},
				// 报警有效时间
				disappearTime: null,
				// timer 自动移除
				timer_autoDisappear: null,
				
                /**
	             * @Des wsPlayerFilter
	             * @Auth
	             * @Date 2021/8/6
	             */
                wsPlayerFilter: {
                	// 创建 ws flag
                	creatWsFlag: true,
                	// 连接已打开
                	wsOnopen: null,
                	// 连接发生错误
                	wsOnerror: this.wsOnerrorPlayer,
                	// 连接关闭
                	wsOnclose: this.wsOnclosePlayer,
                	// 数据推送
                	wsOnmessage: this.wsOnmessagePlayer,
                },
                // wsPlayer elem
                palyerSub: this.$refs.wsPlayer,
                
                // flag 隧道类型App
                tunnelAppFlag: false,
                // 操作按钮
                handleFilters: {
                	// 显示/隐藏 里程
                	showMileageFlag: !this.hideMileageFlag,
                	// 显示/隐藏 基站
                	showBsFlag: !this.hideBsFlag,
                	// 显示/隐藏 电子围栏
                	showFenceFlag: !this.hideFenceFlag,
                	// 开始/结束 点名
                	rollCallFlag: false,
                	// 显示/隐藏 工具柜
                	showTkFlag: false,
                },
                
                // 电子围栏 filters
                eFenceFilters: {
                	// 电子围栏类型
					eType: null,
					// tab title
					label: '',
					/**
					 * @Des 围栏 报警类型
					 * @Auth
					 * @Date 
					 */
					eTypes: [],
                },
                
                // 地图信息
                map_library: new this.HashMap(),
                // 标签用户
                map_tag_user: new this.HashMap(),
                // 标签报警
                map_tag_alarm: new this.HashMap(),
                // 标签位置
                map_tag_in_position: new this.HashMap(),
                
                // 人员定位列表
                map_people_position_list: new this.HashMap(),
                // 人员报警列表
                map_people_alarm_list: new this.HashMap(),
                
                // 当前地图 位置信息
                map_list_position: new this.HashMap(),
                
                // 绑定人员 数量
                bdUserNum: 0,
                // 人员
                users: [],
                // 报警数 人员
                alarmNum_user: 0,
                userGroups: [],// 人员分组
            	/**
                 * @Des 用户组树数据
                 * @Auth
                 * @Date
                 */
                uGroupSelectTree:{
                    placeholder: '请选择人员组',
                    keywordFilter: false,
                    showBox: false,
                    childBox: false,
                    parentBox: false,
                },
                // filters 人员
                userFilters: {
	                typeId: '',// 人员类型
	                groupId: '',// 人员分组
	                keyword: '',// 关键字
                },
                
                // 天车吊钩
                HookImg: HookImg,
                // 车辆
                CarImg: CarImg,
                // 车辆
                cars: [],
                // 工具
                tools: [],
                // 报警数 工具
                alarmNum_tool: 0,
                // 电子围栏
                fences: [],
                // 基站
                baseStations: [],
                // 工具柜
                toolkits: [],
                
				// 摄像头信息
				map_list_cameras: new this.HashMap(),
				// filters 参数 摄像头
				cameraFilters: {
					readMode: '',
					brand: '',
					keywords: '',
					orderBy: {
						"disk_ip": "asc",
						"disk_channel_no": "asc",
						"camera_ip": "asc",
						"number": "asc"
					},
					sortOrders: ["ascending", "descending"],
					sortable: 'custom',
				},// cameraFilters
                
                // 点名
                rollCallFilters: {
                	// 是否展示信息框
                	infoFlag: false,
                	// 点名区域
                	sceneScope: [],
                	// 当前展示项 key
                	onKey: 'prisoners',
                	// 当前展示项 list
                	onRows: [],
                	// 干警 list
                	polices: [],
                	// 犯人 list
                	prisoners: [],
                	// 工具 list
                	tools: [],
                },
                
                map_list_alarmBlack: new this.HashMap(),			// 缓存  黑名单 报警
				map_list_alarmNew: new this.HashMap(),				// 缓存  新报警 报警
				map_list_videoWill: new this.HashMap(),				// 缓存  视频追踪 未成功打开
				map_list_trackPeo: new this.HashMap(),				// 缓存  被追踪人员
				map_list_videoed: new this.HashMap(),				// 缓存  可自动视频追踪 未发送
				map_list_canVoice: new this.HashMap(),				// 缓存 可播放声音
				
				// "880110010001000B"
				trackedIds: [],										// 记录 追踪id
				trackedRows: [],									// 记录 追踪row
				videoedIds: [],										// 记录 视频追踪id
				cordAlarmRows: [],									// 记录 报警列表 tab
				sceneScope: [],										// 多边形数据
				
				// 追踪
				cancelTids: [],										// 记录自动移除的trackId
				
				maxVnum: 1,											// 最多允许展示视频数量
				maxTrackNum: 1,										// 最多允许追踪数量 -1不限制
				noneMsgFlags: {},									// 是否可展示 不在视频区域 信息框 开关集合
				
				cpuPercent: 70,										// cpu 利用率
				ramPercent: 80,										// ram 利用率
				
				// 变量 队列
				isDrawing: false,									// 状态 绘制地图图元
				queueKeys: [],										// 队列 设备keys
				blockNum_cord: 0,									// 阻塞数量 已接收
				stack_cord: {},										// 队列 接收数据
				stack_drawing: {},									// 队列 绘制图元
				fullNum_dChannal: 100,								// 容量 单通道
				channalNum_drawing: 1,								// 通道数量 绘制图元
				
				timer_parsin: null,									// 计时器 延时解析
				freshTime_draw: 10,									// 遍历 通道 间隔
				timer_drStack: null,								//计时器 队列解析
				drIndex: 0,											// 模拟下标 key 解析通道
				channal_stopped: false,								// 解析状态 停止
				
				// 变量
				screenMode: (GlobalVariable.OPEN_VIDEO ? 1 : 0),	// 视频屏幕 模式 1: 单屏 , 2: 双屏,  0: 禁止视频追踪
				videoPlayerMode: GlobalVariable.VIDEO_PLAYER_MODE,	// 播放器类型 0、无播放器 1、VLCPlayer 2、WebrtcPlayer
				infoWindow: null,									// 分屏
				layIndex_video: null,								// 记录 视频页面 index
				isOpend_video: false,								// 记录 视频页面 打开状态
				canDoCancel: true,									// 是否可进行取消操作
				inClosing_layer: false,								// 是否处于视频窗页面关闭过程
				
				// 视频队列
				queueTrackIds: [],									// 记录将要展示的trackId
				timer_show_video: null,								// 定时器 打开视频
				
				// websoket palyer
				map_list_IDs: new this.HashMap(),					// 已展示视频 trackId: vId;
				vInfo: {},											// 视频参数信息
				vPlayNum: 0,										// 已展示视频 个数
				rate_video: 1,										// 记录视频倍速
				index_layer_cpuRam: null,							// 性能提示记录
				timer_videos_reopen: null,							// 计时器，重新打开视频
				index_videos_reopen: 0,								// 下标，重新打开视频
				
				/**
				 * 消失报警对视频影响
				 * 
				 * @keys: 'open': 自动视频追踪; 'none': 不作限制; 'close': 禁止自动视频追踪;
				 * 
				 */ 
				videoState_4: 'close',
				
				/**
				 * 消失报警对视频影响
				 * 
				 * @keys: true;  false; 基于 videoState_4 === 'close' 起作用;
				 * 
				 * @values: close + true: 消失状态取消后,恢复视频检索; close + false: 消失状态取消后,不恢复视频检索;
				 * 
				 */ 
				recoverVideo_4: false,
				
				// 报警类型 list
				alarmTypes_sort: [
					{key: 4, val: '消失报警'},
					{key: 1, val: '求助报警'},
					{key: 18, val: '防撞报警'}, {key: 11, val: '周界报警'},
					{key: 3, val: '出界报警'}, {key: 2, val: '入界报警'},
					{key: 5, val: '区域入界报警'}, {key: 6, val: '带离报警'},
					{key: 8, val: '高空坠落'}, {key: 9, val: '塌方砸倒'},
					{key: 7, val: '低电量报警'}
				],
				// 视频追踪 alarm 求助报警/出界报警/入界报警
				alarmTypes_track: (this.videoState_4 === 'open' ? [1, 3, 2, 18, 11, 4] : [1, 3, 2, 18, 11]),
				
				// 上拉加载
				infiniteId: +new Date(),
				// 参数 上拉加载
				infiniteFilters: {
					limit: 100,// 每页条数
					page: 1,// 页码
					showAllFlag: false,// 加载完毕
				},
				// 人员信息列表
				userList: [],
				// 计时器 上拉加载
            	timer_infinite: null,
            }
        },
        mounted() {
			// svg elem
            this.mapSub = this.$refs.svgMap;
            
			// 查询结构
			this.searchOrg();
			// 查询围栏类型
			this.searchETypes();
			
			// wsPlayer elem
			this.palyerSub = this.$refs.wsPlayer;
			
			// 查询用户组
	        this.searchUserGroup()
			
			// 开启 消息订阅
        	this.startSubscribes();
			
			// 初始化数据
			//this.initDatas();
			
			// 监听页面
			window.addEventListener('beforeunload', this.closeVideoWin, false);
			
			// 播放器 发送数据 握手
			this.changePlayerDate({code: 'linkstatus', data: new Date().getTime(), pageMarker: 'intime', msg: '握手'});
        },
        /**
         * @Des 加载完成
         * @Auth
         * @Date 2021/8/6
         */
        created() {
        	// 开启 消息订阅
        	//this.startSubscribes();
        	
        	// query 参数
			this.queryParams = Object.assign({}, this.$route.query);
        	this.filters.areaId = this.queryParams.areaId || '';
        	this.filters.mapId = this.queryParams.mapId || '';
        },
        /**
         * @Des 销毁
         * @Auth
         * @Date 2021/8/6
         */
        beforeDestroy() {
        	// 关闭 消息订阅
        	this.endSubscribes();
        	const time = new Date().getTime();
        	const sign = Secret.md5(time + "{" + 2 + "}");
        	// 发布消息 地图断连
        	this.$pubsub.publish('sendPositionWs', {code: 2, areaId: '', mapId: '', time: time,sign: sign});
        	// 销毁 svg地图
			this.mapSub.destroySvg();
			// 关闭视频弹窗
			this.closeVideoWin();
			
			// 关闭 timer
        	this.endTimers();
        	
        	// 监听页面
			window.removeEventListener('beforeunload', this.closeVideoWin, false);
        },
        /**
         * @Des 监听
         * @Auth
         * @Date 2021/8/6
         */
        watch: {
            
        },
        methods: {
            /**
             * @Des 切换折叠面板状态
             * @Auth
             * @Date
             */
            toggleFold(foldV) {
            	// 空值 中止
            	if (this.$checkEmpty(foldV)) return false;
            	
            	// 处于追踪状态 不做收起处置
            	if (this.map_list_trackPeo.size() > 0) {
            		if (this.foldValue != foldV) {
            			this.foldValue = foldV;
            		}
            		return false;
            	}
            	
            	// 折叠面板
            	this.foldValue = this.foldValue == foldV ? '' : foldV;
            },// toggleFold
            
            /**
             * @Des 上拉加载
             * @Auth
             * @Date
             */
            infiniteHandler($state) {
            	// console.log('上拉加载', $state);
            	
            	// 清除计时器
            	if (this.timer_infinite != null) {
            		clearTimeout(this.timer_infinite);
            		this.timer_infinite = null;
            	}
            	
            	if (this.infiniteFilters.showAllFlag) {
        			// 加载完毕
        			this.userList.length > 0 && $state.loaded();
        			$state.complete();
        			return false;
        		}
            	
            	// 计时器 上拉加载
            	this.timer_infinite = setTimeout(() => {
            		// 上拉加载
            		// this.infiniteId += 1;
            		//$state.reset();
              		//$state.loaded();
            		//$state.error();
            		//$state.complete();
            		
            		if (this.infiniteFilters.showAllFlag) {
            			// 加载完毕
            			this.userList.length > 0 && $state.loaded();
            			$state.complete();
            			return false;
            		}
            		
            		// 参数 上拉加载
            		this.infiniteFilters.page += 1;
            		
            		// 数据更新 userList
            		this.flushUserList();
            		
            		if (this.userList.length <= 0) {
            			// 暂无数据
            			$state.complete();
            		} else if (this.infiniteFilters.showAllFlag) {
            			// 加载完毕
            			$state.loaded();
            			$state.complete();
            		} else {
            			$state.loaded();
            		}
            		
            		clearTimeout(this.timer_infinite);
            		this.timer_infinite = null;
            	}, 1*1000);
            	
            },// infiniteHandler
            /**
             * @Des 上拉加载 参数重置
             * @Auth
             * @Date
             */
            resetInfinite() {
            	// 上拉加载
				this.infiniteId += 1;
				// 参数 上拉加载
				this.infiniteFilters = {
					limit: 100,// 每页条数
					page: 1,// 页码
					showAllFlag: false,// 加载完毕
				};
				// 人员信息列表
				this.userList = [];
            },// resetInfinite
            /**
             * @Des 数据更新 userList
             * @Auth
             * @Date
             */
            flushUserList() {
            	let total = this.infiniteFilters.limit * this.infiniteFilters.page;
            	
            	let users = Object.assign([], this.users);
            	let userList = [];
            	users.forEach((row, index) => {
            		if (!(
						(!this.$checkEmpty(this.userFilters.typeId) && String(this.userFilters.typeId) != String(row.userData.typeId)) ||
						(!this.$checkEmpty(this.userFilters.groupId) && String(this.userFilters.groupId) != String(row.userData.groupId)) ||
						(!this.$checkEmpty(this.userFilters.keyword) && (row.userData.userName.indexOf(this.userFilters.keyword) == -1 && row.userData.userNamePy.toUpperCase().indexOf(this.userFilters.keyword.toUpperCase()) == -1 && row.userData.userNo.indexOf(this.userFilters.keyword.toUpperCase()) == -1 && row.userData.tagId.indexOf(this.userFilters.keyword.toUpperCase()) == -1 ))
	 					)) {
            			userList.push(Object.assign({}, row));
            		}
            		
            		// 满值 中止
            		// if (index >= total -1) users.forEach.break = new Error("user list complete");
            	});
            	// 人员信息列表
				this.userList = Object.assign([], userList).splice(0, total);
            	
            	if (total >= userList.length) {
            		// 加载完毕
            		
            		// 参数 上拉加载
            		this.infiniteFilters.showAllFlag = true;
            	} else {
            		// 有剩余项
            		
            		// 原加载完毕
            		if (this.infiniteFilters.showAllFlag) {
            			// 上拉加载
            			this.infiniteId += 1;
            		}
            		// 参数 上拉加载
            		this.infiniteFilters.showAllFlag = false;
            	}
            },// flushUserList
            
            /**
             * @Des 查询用户组
             * @Auth
             * @Date
             */
	        searchUserGroup() {
	            this.$request.postJsonRequest(ApiUser.searchUserGroupApi,{
	                projectId: this.$store.state.currentProjectId
	            }).then(result => {
	                this.userGroups = [];
	                this.userTypes = [];
	                if(result.code == 0){
	                  result.data.forEach((row, index) => {
	                    if(row.type == 1){
	                      this.userTypes.push(row);
	                    }
	                  })
	                  this.userGroups = GlobalFun.dataToTree(Object.assign([], result.data), {
	                      id: 'id',
	                      pid: 'parentId',
	                      children: 'children',
	                      label: 'name'
	                  });
	                }
	            }).catch(error => {
	                console.error('查询用户组异常', ApiUser.searchUserGroupApi, error);
	            })
	        },// searchUserGroup
            /**
             * @Des 选择值改变
             * @Auth
             * @Date
             */
            setSelectVal_u(val){
                if(val && val.id){
                    if(val.parentId == 0){
                        this.userFilters.typeId = val.id.replace("T","");
                        this.userFilters.groupId = '';
                    }else{
                        // this.userFilters.typeId = val.parentId.replace("T","");
                        this.userFilters.groupId = val.id;
                    }
                    this.$refs['userTreeSelect'].setSelectVal(val);
                }else{
                    this.userFilters.typeId = '';
                    this.userFilters.groupId = '';
                    this.$refs['userTreeSelect'].setSelectVal({});
                }
                
                // 过滤人员
                this.filterUsers();
            },// setSelectVal_u
            /**
             * @Des 过滤人员
             * @Auth
             * @Date
             */
            filterUsers() {
            	if (this.foldValue != 'user') {
        			this.foldValue = 'user';
        		}
            	
            	// 上拉加载 参数重置
            	this.resetInfinite();
            	// 数据更新 userList
            	this.flushUserList();
            },// filterUsers
            /**
        	 * @Des 关闭 timer
        	 * @Auth
        	 * @Date
        	 */
        	endTimers() {
        		// 清除计时器
				if (this.timer_autoDisappear != null) {
					clearTimeout(this.timer_autoDisappear);
					this.timer_autoDisappear = null;
				}
				// 清除计时器 阻塞数据
				if (this.timer_parsin != null) {
					clearTimeout(this.timer_parsin);
					this.timer_parsin = null;
				}
				// 清除计时器
				if (this.timer_drStack != null) {
					clearTimeout(this.timer_drStack);
					this.timer_drStack = null;
				}
				// 清除计时器
				if (this.timer_show_video != null) {
					clearInterval(this.timer_show_video);
					this.timer_show_video = null;
				}
				// 清除计时器
				if (this.timer_videos_reopen != null) {
					clearInterval(this.timer_videos_reopen);
					this.timer_videos_reopen = null;
				}
				// 清除计时器
				if (this.timer_fold_mini != null) {
					clearInterval(this.timer_fold_mini);
					// 计时器 fold mini
					this.timer_fold_mini = null;
				}
				// 清除计时器
            	if (this.timer_infinite != null) {
            		clearTimeout(this.timer_infinite);
            		this.timer_infinite = null;
            	}
        	},
            /**
             * @Des 开启 消息订阅
             * @Auth
             * @Date 2021/8/9
             */
            startSubscribes() {
				
				// 订阅 相关 信息
				this.sub_initLocalData = this.$pubsub.subscribe('initLocalData', (name, data) => {
					// console.log(name, Object.assign({}, data));
					
					// 遍历data
					for(let key in data) {
						let fnName = null;
						switch (key) {
							case 'alarmStates':
								fnName = 'flushAlarmFlushStates';
								break;
							case 'alarmStateSwitchs':
								fnName = 'flushAlarmFlushStateSwitchs';
								break;
							case 'mapsInfo':
								fnName = 'flushMaps';
								break;
							case 'tagUsersInfo':
								fnName = 'flushTagUsers';
								break;
							case 'tagAlarmsInfo':
								fnName = 'flushTagAlarms';
								break;
							case 'tagPositionsInfo':
								fnName = 'flushTagPositions';
								break;
							case 'positionKsListInfo':
								fnName = 'flushPositionKsList';
								break;
							case 'alarmKsListInfo':
								fnName = 'flushAlarmKsList';
								break;
							case 'toolcabinetListInfo':
								fnName = 'flushToolcabinetList';
								break;
							default:
								fnName = null;
						};
						// 刷新数据
						fnName && typeof this[fnName] == 'function' && this[fnName](data[key]);
					};
					
					// 刷新 列表
					if (data.flushListFlag) {
						this.flushListData();
					}
					// 刷新 位置
					if (data.flushPositionFlag) {
						// 刷新全部 位置
						this.flushMapPositions();
					}
					
					// 刷新 定位有效时间
					if (data.flushDisappearTimeFlag) {
						// 更新数据 定位有效时间
						this.flushDisappearTime(data.disappearTime);
					}
					
				});
            	
            	// 订阅 ws
				this.sub_wsPositionInfo = this.$pubsub.subscribe('wsPositionInfo', (name, data) => {
					//接收数据
					this.receiveData({data: data});
				});
				
				// 订阅 ws
				this.sub_wsCreated = this.$pubsub.subscribe('wsCreated', (name, data) => {
					const time = new Date().getTime();
					const sign = Secret.md5(time + "{" + 2 + "}");
					
					// 发布消息 地图连接
					this.$pubsub.publish('sendPositionWs', {code: 2, areaId: this.filters.areaId, mapId: this.filters.mapId, time: time,sign: sign});
				});
				
				// 订阅 ws 视频配置
				this.sub_videoChange = this.$pubsub.subscribe('VideoChange', (name, data) => {
					// 查询 摄像头
					this.searchCameras();
				});
				// 订阅 ws 电子围栏
				this.sub_eFenceChange = this.$pubsub.subscribe('EFenceChange', (name, data) => {
					// 查询 电子围栏
					this.searchFence();
				});
				
				// 订阅 播放器 Player Onmessage
				this.sub_PlayerOnmessage = this.$pubsub.subscribe('PlayerOnmessage', (name, data) => {
					// 播放器 数据改变
					this.playerOnmessage(data);
				});
            },
            /**
             * @Des 关闭 消息订阅
             * @Auth
             * @Date 2021/8/9
             */
			endSubscribes() {
				// 取消订阅 相关信息
				this.$pubsub.unsubscribe(this.sub_initLocalData);
				
				// 取消订阅 ws
				this.$pubsub.unsubscribe(this.sub_wsPositionInfo);
				
				// 取消订阅 ws连接
				this.$pubsub.unsubscribe(this.sub_wsCreated);
				
				// 取消订阅 ws 视频配置
				this.$pubsub.unsubscribe(this.sub_videoChange);
				
				// 取消订阅 ws 电子围栏
				this.$pubsub.unsubscribe(this.sub_eFenceChange);
				
				// 订阅 播放器 Player Onmessage
				this.$pubsub.unsubscribe(this.sub_PlayerOnmessage);
			},
            
            /**
             * @Des 查询 组织结构
             * @Auth
             * @Date 
             */
            searchOrg() {
                // 加载 组织结构 flag
				this.orgLoadingFlag = true;
                this.$request.postJsonRequest(ApiOam.Find_Org_Uri,{
                    projectId: this.$store.state.currentProjectId
                }).then(result => {
                    // 组织结构 list
                    this.orgList = Object.assign([], result.data);
                    
                    let orgAreas = [];// 区域
                    let orgMaps = [];// 地图
                    // 缓存
					this.map_list_areas.clear();
                    // 缓存 区域
                    this.orgList.forEach((row, index) => {
                    	// 空值 跳过
                    	if (this.$checkEmpty(row) || this.$checkEmpty(row.node)) return true;
                    	
                    	if (row.level == 2) {
                    		// 区域
                    		orgAreas.push(Object.assign({}, row.node, {label: row.node.areaName}));
                    		// 缓存
                    		this.map_list_areas.put(row.areaId, Object.assign({}, row.node, {label: row.node.areaName}));
                    	}
                    	if (row.level == 3) {
                    		// 地图
                    		orgMaps.push(Object.assign({}, row.node));
                    	}
                    });
                    
                    // 区域
                    this.areas = Object.assign([], orgAreas);
                    // 地图
                    this.orgMaps = Object.assign([], orgMaps);
                    
                    // 当前选中项
                    let currItem = this.getCurrItem(this.areas, this.filters.areaId, 'areaId');
                    // 切换区域
                    this.changeArea(currItem);
                    
                    // 加载 组织结构 flag
                    this.orgLoadingFlag = false;
                }).catch(error => {
                    console.error('查询组织结构异常', ApiOam.Find_Org_Uri, error);
                    // 加载 组织结构 flag
                    this.orgLoadingFlag = false;
                })
            },
            
            /**
             * @Des 切换区域
             * @Auth
             * @Date 2021/8/6
             */
            changeArea(row) {
            	// 正在点名
            	if (this.handleFilters.rollCallFlag) return false;
            	
            	// 关闭 消息订阅
				this.endSubscribes();
				
            	// filters
            	this.filters.areaId = Object.assign({areaId: '', mapId: ''}, row).areaId;
            	// sceneScope
            	this.sceneScope = [];
            	
            	// 查询地图
            	this.searchMaps();
            },
            
            /**
		     * @Des 处理Command 地图
		     * @Auth 
		     * @Date 
		     */
			handleCommand_map(command){
				//点击切换地图
				this.clickMapRow(command);
			},
            
            /**
             * @Des 查询地图
             * @Auth
             * @Date 2021/8/6
             */
            searchMaps() {
                // 地图集合
                this.maps = [];
                // 缓存
				this.map_list_maps.clear();
				
                // 缓存 地图
                this.orgMaps.forEach((row, index) => {
                	// 空值 跳过
                	if (this.$checkEmpty(row)) return true;
                	
                	// 没有区域 || 地图处于当前区域
                	if (this.$checkEmpty(this.areas) || row.areaId == this.filters.areaId) {
                		let itemRow = Object.assign({}, row);
                		// 检索 当前区域
                		let currArea = this.map_list_areas.get(this.filters.areaId);
                		// 区域有地铁
                		if (!this.$checkEmpty(currArea) && currArea.hasMap == 1) {
                			itemRow.pStartPointX = currArea.startPointX;
                			itemRow.pStartPointY = currArea.startPointY;
                			itemRow.pStartPointZ = currArea.startPointZ;
                			itemRow.pHasMap = true;
                		}
                		// 缓存 地图
                		this.maps.push(Object.assign({}, itemRow));
                		// 缓存
                		this.map_list_maps.put(row.mapId, Object.assign({}, itemRow));
                	}
                });
                
                // 当前选中项
                let currItem = this.getCurrItem(this.maps, this.filters.mapId, 'mapId');
                // 目标空值
                if (this.$checkEmpty(currItem)) {
                	// 检索 当前区域
                	let currArea = this.map_list_areas.get(this.filters.areaId);
                	if (!this.$checkEmpty(currArea) && !this.$checkEmpty(currArea.mapUrl)) {
                		// 初始化 svg地图
						//this.mapSub.initMap(Object.assign({}, currArea, {mapUrl: (GlobalVariable.BASE_PATH + currArea.mapUrl)}));
						this.mapSub.initMap(Object.assign({}, currArea, {mapUrl: ('data:image/png;base64,' + currArea.mapUrl), mapLevel: 1, tunnelPoints: currArea.tunnelPoints}));
		            	// 查询 电子围栏
		            	this.searchFence();
		            	// 查询 基站
		            	this.searchBaseStation();
		            	// 查询 摄像头
		            	this.searchCameras();
		            	// 查询 里程
		            	this.searchMileage();
		            	// 查询 工具柜
		            	//this.searchToolkits();
		            	
		            	// 初始化 当前场景 人员信息
		            	this.initPosiData();
                	} else {
                		// 切换地图
                		this.changeMap(this.maps[0]);
                	}
                	return false;
                }
                // 切换地图
                this.changeMap(currItem);
            },
            /**
             * @Des 切换地图
             * @Auth
             * @Date 2021/8/6
             */
            changeMap(row) {
            	// 正在点名
            	if (this.handleFilters.rollCallFlag) return false;
            	
            	// 关闭 消息订阅
				this.endSubscribes();
            	
            	// 清除图元 实时定位
				this.clearMapFences();
            	
            	// 空值 中止
            	if (this.$checkEmpty(row)) {
	            	// filters
					this.filters.mapId = null;
            		// 更新数据
                    this.fences = [];
            		
            		// 销毁 svg地图
					this.mapSub.destroySvg();
            		return false;
            	};
            	
            	// filters
            	this.filters.mapId = Object.assign({areaId: '', mapId: ''}, row).mapId;
            	
            	// 初始化 svg地图
				//this.mapSub.initMap(Object.assign({}, row, {mapUrl: (GlobalVariable.BASE_PATH + row.mapUrl)}));
				this.mapSub.initMap(Object.assign({}, row, {mapUrl: ('data:image/png;base64,' + row.mapUrl), mapLevel: 2, tunnelPoints: row.tunnelPoints}));
            	// 查询 电子围栏
            	this.searchFence();
            	// 查询 基站
            	this.searchBaseStation();
            	// 查询 摄像头
            	this.searchCameras();
            	// 查询 里程
            	this.searchMileage();
            	// 查询 工具柜
            	//this.searchToolkits();
            	
            	// 初始化 当前场景 人员信息
            	this.initPosiData();
            },
            /**
             * @Des 当前选中项
             * @Auth
             * @Date 2021/8/6
             */
            getCurrItem(rows, onkey, key) {
            	// 空值 中止
            	if (this.$checkEmpty(rows)) return false;
            	
            	// onrow
            	let onRow = null;
            	// 遍历 检索
            	rows.forEach((row, index) => {
            		if (onkey == row[key]) {
            			onRow = row;
            		}
            	});
            	
            	return (onRow == null && key != 'mapId' ? rows[0] : onRow);
            },
            /**
             * @Des 点击切换区域
             * @Auth
             * @Date 2021/8/6
             */
            clickAreaRow(row) {
            	// 正在点名
            	if (this.handleFilters.rollCallFlag) return false;
            	
            	// 自动切换
				var trackPeoNum = this.map_list_trackPeo.size();
				var isTrackedOne = trackPeoNum == 1;// && trackedIds.length == 1;
				// 单人追踪
				if(isTrackedOne) {
					this.$confirm('当前处于单人追踪状态！确认切换区域并且取消单人追踪？', '询问', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						// 移除缓存
						if( this.map_list_trackPeo.containsKey(this.trackedIds[0]) ) this.map_list_trackPeo.remove(this.trackedIds[0]);
						// 初始化追踪状态 取消追踪图标
						this.initTrackImgs(this.trackedIds[0]);
						// 更新 追踪记录rows
						this.flushTrackedRows();
						// 记录单人追踪状态
						this.filters.trackedOne = false;
						// filters
						this.filters.mapId = null;
						// 切换区域
						this.changeArea(row);
					}).catch(() => {
						
					});
					return false;
				}
				// filters
				this.filters.mapId = null;
            	// 切换区域
            	this.changeArea(row);
            },
            /**
             * @Des 点击切换地图
             * @Auth
             * @Date 2021/8/6
             */
			clickMapRow(row) {
				// 正在点名
            	if (this.handleFilters.rollCallFlag) return false;
				
				// 自动切换
				var trackPeoNum = this.map_list_trackPeo.size();
				var isTrackedOne = trackPeoNum == 1;// && trackedIds.length == 1;
				// 单人追踪
				if(isTrackedOne) {
					this.$confirm('当前处于单人追踪状态！确认切换区域并且取消单人追踪？', '询问', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						// 移除缓存
						if( this.map_list_trackPeo.containsKey(this.trackedIds[0]) ) this.map_list_trackPeo.remove(this.trackedIds[0]);
						// 初始化追踪状态 取消追踪图标
						this.initTrackImgs(this.trackedIds[0]);
						// 更新 追踪记录rows
						this.flushTrackedRows();
						// 记录单人追踪状态
						this.filters.trackedOne = false;
						// 切换地图
						this.changeMap(row);
					}).catch(() => {
						
					});
					return false;
				}
				// 切换地图
				this.changeMap(row);
			},
            /**
             * @Des 点击切换地图 总览图
             * @Auth
             * @Date 2021/9/28
             */
			clickShowAreaMap() {
				// 正在点名
            	if (this.handleFilters.rollCallFlag) return false;
				
				// 自动切换
				var trackPeoNum = this.map_list_trackPeo.size();
				var isTrackedOne = trackPeoNum == 1;// && trackedIds.length == 1;
				// 单人追踪
				if(isTrackedOne) {
					this.$confirm('当前处于单人追踪状态！确认切换区域并且取消单人追踪？', '询问', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						// 移除缓存
						if( this.map_list_trackPeo.containsKey(this.trackedIds[0]) ) this.map_list_trackPeo.remove(this.trackedIds[0]);
						// 初始化追踪状态 取消追踪图标
						this.initTrackImgs(this.trackedIds[0]);
						// 更新 追踪记录rows
						this.flushTrackedRows();
						// 记录单人追踪状态
						this.filters.trackedOne = false;
						// 展示 总览图
						this.showAreaMap();
					}).catch(() => {
						
					});
					return false;
				}
				// 展示 总览图
				this.showAreaMap();
			},
			/**
             * @Des 展示 总览图
             * @Auth
             * @Date 2021/9/28
             */
			showAreaMap() {
				// 正在点名
            	if (this.handleFilters.rollCallFlag) return false;
				
				// 置空 mapId
				this.filters.mapId = null;
				
				// 关闭 消息订阅
				this.endSubscribes();
				// 检索 当前区域
            	let currArea = this.map_list_areas.get(this.filters.areaId);
            	if (!this.$checkEmpty(currArea) && !this.$checkEmpty(currArea.mapUrl)) {
            		// 初始化 svg地图
					//this.mapSub.initMap(Object.assign({}, currArea, {mapUrl: (GlobalVariable.BASE_PATH + currArea.mapUrl)}));
					this.mapSub.initMap(Object.assign({}, currArea, {mapUrl: ('data:image/png;base64,' + currArea.mapUrl), mapLevel: 1, tunnelPoints: currArea.tunnelPoints}));
	            	// 查询 电子围栏
	            	this.searchFence();
	            	// 查询 基站
	            	this.searchBaseStation();
	            	// 查询 摄像头
	            	this.searchCameras();
	            	// 查询 里程
	            	this.searchMileage();
	            	// 查询 工具柜
	            	//this.searchToolkits();
	            	
	            	// 初始化 当前场景 人员信息
	            	this.initPosiData();
            	} else {
            		// 销毁 svg地图
					this.mapSub.destroySvg();
            	}
			},
            
            /**
			 * @Des 提取更新时间
			 * @Auth 
			 * @Date 
			 */
			extractUpdateTime(tagId) {
				// 空值 中止
				if (this.$checkEmpty(tagId)) return '--';
				
				let row = this.map_list_position.get(tagId);
				// 空值 中止
				if (this.$checkEmpty(row) || (this.$checkEmpty(row.updateTime) && this.$checkEmpty(row.time))) return '--';
				let time = !this.$checkEmpty(row.updateTime) ? row.updateTime : row.time;
				return this.$moment(time).format('YYYY-MM-DD HH:mm:ss');
			},
            
            /**
			 * @Des 检索是否为隧道地图
			 * @Auth 
			 * @Date 
			 */
            checkTunnelAppFlag () {
            	// 空值 中止
            	if (this.$checkEmpty(this.filters.mapId)) {
            		// flag 隧道类型App
            		this.tunnelAppFlag = false;
            		return false;
            	}
            	
            	// 默认为非隧道类型
            	let tunnelAppFlag = false;
            	
            	let mapRow = this.map_list_maps.get(this.filters.mapId);
            	if (!this.$checkEmpty(mapRow) && !this.$checkEmpty(mapRow.appId)) {
            		tunnelAppFlag = this.$store.state.tunnelAppIds.indexOf(mapRow.appId) != -1;
            	}
            	
            	// flag 隧道类型App
                this.tunnelAppFlag = tunnelAppFlag && true;
            	
            	return tunnelAppFlag;
            },
            
            // ======================================= 电子围栏 start ============================================ \\
            /**
             * @Des 切换围栏展示状态
             * @Auth
             * @Date 
             */
            toggleFenceFlag() {
				// flag 展示 电子围栏
				this.handleFilters.showFenceFlag = !this.handleFilters.showFenceFlag;
				
				// 清除图元 电子围栏
				!this.handleFilters.showFenceFlag && this.clearMapFences();

				// 刷新地图图元 电子围栏
				this.handleFilters.showFenceFlag && this.searchFence();
            },
            /**
		     * @Des 处理Command 地图
		     * @Auth 
		     * @Date 
		     */
			handleCommand_eFence(command){
				// 电子围栏 类型
				this.eFenceFilters.eType = command.val;
				// 电子围栏 title
				this.eFenceFilters.label = command.label;
				
				// 显示/隐藏 电子围栏
				this.handleFilters.showFenceFlag = !this.$checkEmpty(this.eFenceFilters.eType);
				
				// 查询 电子围栏
				this.searchFence();
			},
            
			/**
			 * @Des 查询围栏类型
			 * @Auth
			 * @Date
			 */
			searchETypes() {
				this.$SubFn.searchETypes(this, (data) => {
					// 围栏 报警类型
					this.eFenceFilters.eTypes = Object.assign([], data);
					
					// 显示/隐藏 电子围栏
                	if (this.handleFilters.showFenceFlag && !this.eFenceFilters.eType && !this.$checkEmpty(this.eFenceFilters.eTypes)) {
                		// 电子围栏 类型
						this.eFenceFilters.eType = this.eFenceFilters.eTypes[0].val;
						// 电子围栏 title
						this.eFenceFilters.label = this.eFenceFilters.eTypes[0].label;
                	}
				});
			},
            /**
             * @Des 查询 电子围栏
             * @Auth
             * @Date 2021/8/6
             */
            searchFence() {
				
				// 清除图元 电子围栏
				this.clearMapFences();
				
				// 展示 电子围栏
				if (!this.handleFilters.showFenceFlag || !this.eFenceFilters.eType) return false;
				
				// 交互 参数
				let formData = {
					projectId: this.$store.state.currentProjectId,
					subsectionId: this.filters.areaId,
					mapId: this.filters.mapId,
					eType: parseInt(this.eFenceFilters.eType),
				};
				// 交互
				this.$request.postJsonRequest(ApiFence.searchFenceApi, formData).then(result => {
                    
                    // 更新数据
                    this.fences = !this.$checkEmpty(result.rows) ? result.rows : [];
                    
                    // 绘制图元
                    this.refreshMapFences();
                    
                }).catch(error => {
                    console.error('查询电子围栏异常', ApiFence.searchFenceApi, error);
                })
            },
            
			/**
			 * @Des 清除图元 电子围栏
			 * @Auth
			 * @Date 2021/8/6
			 */
			clearMapFences() {
				// 清除 图元
				this.fences.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row)) return true;
					
					// 绘制 实时定位
					this.mapSub.clearRail(row.id, 'destroy');
				});
			},
			/**
			 * @Des 绘制图元 电子围栏
			 * @Auth
			 * @Date 2021/8/6
			 */
			refreshMapFences() {
				// 展示 电子围栏
				if (!this.handleFilters.showFenceFlag) return false;
				
				// 重新绘制
				this.fences.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row)) return true;
					
					// points
					let points = row.points.split(';');
					points.push(points[0]);
					// lineObj
					let lineObj = {color: 'blue', width: 4};
					// railObj
					let railObj = {id: row.id, row: row, points: points, lineObj: lineObj};
					
					// 绘制 实时定位
					this.mapSub.loadRail(railObj);
				});
			},
			// ======================================= 电子围栏 end ============================================ \\
			
			// ======================================= 基站 start ============================================ \\
			/**
             * @Des 查询基站
             * @Auth
             * @Date 2021/11/17
             */
            searchBaseStation() {
				// 清除 图元
				this.mapSub.clearAllStations('destroy');
				
				// 展示基站
				if (!this.handleFilters.showBsFlag) return false;
				
				// 交互 参数
				let formData = {
					mapId: this.filters.mapId,
					projectId: this.$store.state.currentProjectId
				};
				
				// 交互
				this.$request.postJsonRequest(ApiOam.Search_Uwb_Bs_Uri, formData).then(result => {
                    // 更新数据
                    this.baseStations = !this.$checkEmpty(result.rows) ? result.rows : [];

                    // 刷新地图图元 基站
                    this.refreshMapStations();

                }).catch(error => {
                    console.error('查询基站异常', ApiOam.Search_Uwb_Bs_Uri, error);
                })
            },
            /**
             * @Des 切换基站展示状态
             * @Auth
             * @Date 2021/11/17
             */
            toggleBsFlag() {
				// 展示基站
				this.handleFilters.showBsFlag = !this.handleFilters.showBsFlag;

				// 清除 图元
				this.mapSub.clearAllStations('destroy');

				// 查询 基站
				this.handleFilters.showBsFlag && this.searchBaseStation();
            },
			/**
			 * @Des 刷新地图图元 基站
			 * @Auth
			 * @Date 2021/11/17
			 */
			refreshMapStations() {
				// 展示基站
				if (!this.handleFilters.showBsFlag) return false;

				// 重新绘制
				this.baseStations.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row)) return true;
                    row.index = index;
                    
                    let mapInfoMap = !this.$checkEmpty(row.mapInfoMap) ? Object.assign({}, row.mapInfoMap) : {};
                    // 空值 跳过
                    if (!mapInfoMap.hasOwnProperty(this.filters.mapId) || this.$checkEmpty(row.pointX) || this.$checkEmpty(row.pointY)) {
                    	return false;
                    }
                    
                    // 不在同一区域
                    if (row.subsectionId != this.filters.areaId) return false;
                    // 总览图 跳过
                    if (this.$checkEmpty(this.filters.mapId)) return false;
                    
                    // 绘制 基站
					this.mapSub.loadStationPosition(Object.assign({}, row));
					
                    return true;
                    // mapId
                    let mapIds = row.mapIds.split(',');
                    // pointXPxs
                    let pointXPxs = row.pointXPx.split(',');
                    // pointYPxs
                    let pointYPxs = row.pointYPx.split(',');
                    
                	let onIndex = mapIds.indexOf((this.filters.mapId).toString());
                    // 地图不匹配 跳过
                    if (onIndex == -1) return false;
                    
					// 绘制 基站
					this.mapSub.loadStationPosition(Object.assign({}, row, {pointXPx: parseFloat(pointXPxs[onIndex]), pointYPx: parseFloat(pointYPxs[onIndex])}));
				});
			},
			// ======================================= 基站 end ============================================ \\
			
			// ======================================= 摄像头 start ============================================ \\
			/**
			 * @Des 查询 摄像头
			 * @Auth
			 * @Date
			 */
			searchCameras() {
				if(this.locked_camera) return false;
				this.locked_camera = true;
				
				// 摄像头信息
				this.map_list_cameras.clear();
				this.$request.postJsonRequest(ApiVideo.searchVideoApi, {
					mapId: '',
					readMode: this.cameraFilters.readMode,
					brand: this.cameraFilters.brand,
					keywords: this.cameraFilters.keywords,
					orderBy: this.cameraFilters.orderBy,
					projectId: this.$store.state.currentProjectId,
					offset: 0,
					limit: 0,
					total: 0
				}).then(result => {
					Object.assign([], result.rows).forEach((row, index) => {
						// 空值 跳过
						if (this.$checkEmpty(row) || this.$checkEmpty(row.number)) return true;
						// 摄像头信息
						this.map_list_cameras.put(row.number, Object.assign({}, row));
					});
					this.locked_camera = false;
				}).catch(error => {
					this.locked_camera = false;
					console.error('查询摄像头异常', ApiVideo.searchVideoApi, error);
				})
            },// searchCameras
            // ======================================= 摄像头 end ============================================ \\
			
			// ======================================= 里程 start ============================================ \\
			/**
             * @Des 查询里程
             * @Auth
             * @Date 
             */
            searchMileage() {
				// 清除 图元
				this.mapSub.clearAllRuleLines('destroy');
				
                // 延迟执行
                this.$nextTick(() => {
                	// 刷新地图图元 里程
                	this.refreshMapMileages();
                });
            },
            /**
             * @Des 切换里程展示状态
             * @Auth
             * @Date 
             */
            toggleMileageFlag() {
				// 展示里程
				this.handleFilters.showMileageFlag = !this.handleFilters.showMileageFlag;

				// 清除 图元
				this.mapSub.clearAllRuleLines('destroy');

				// 刷新地图图元 里程
				this.tunnelAppFlag && this.handleFilters.showMileageFlag && this.refreshMapMileages();
            },
			/**
			 * @Des 刷新地图图元 里程
			 * @Auth
			 * @Date 
			 */
			refreshMapMileages() {
				// 展示里程
				if (!this.tunnelAppFlag || !this.handleFilters.showMileageFlag) return false;
				
				// 空值 中止
				if (this.$checkEmpty(this.filters.mapId)) return false;
				
				let mapObj = this.map_list_maps.get(this.filters.mapId)
				// 空值 中止
				if (this.$checkEmpty(mapObj)) return false;
				
				// 比例 X
				let scaleX = mapObj.scaleX;
				let scaleXs = scaleX.split('/');
				// 比例 Y
				let scaleY = mapObj.scaleY;
				let scaleYs = scaleX.split('/');
				
				var ruleLineObj = {
					id: mapObj.mapId,
					mapType: mapObj.mapType,
					scaleX: mapObj.scaleX,
					scaleY: mapObj.scaleY,
					startX: mapObj.startPointXPx,
					startY: mapObj.startPointYPx,
					startMileage: mapObj.startPointX,
					endMileage: parseFloat(scaleXs[1]),
					finishMileage: mapObj.finishMileage,
					workMileage: mapObj.workMileage,
					textOpt: {fill: '#39FCFF'}
				};
				
				// 设置刻度尺数据
				//this.mapSub.setRuleLineData(ruleLineObj);
				
				setTimeout(() => {
					// 画 刻度尺图元
					this.mapSub.loadRuleLine(ruleLineObj);
				}, 500);
				
			},
			// ======================================= 里程 end ============================================ \\
			
			// ======================================= 工具柜 start ============================================ \\
			
			/**
			 * @Des 查询工具柜
			 * @Auth
			 * @Date 2021/12/1
			 */
			searchToolkits() {
				// 清除 图元
				this.mapSub.clearAllTks('destroy');
				
				// 刷新地图图元 工具柜
				this.handleFilters.showTkFlag && this.refreshMapToolkits();
			},
			/**
			 * @Des 切换工具柜展示状态
			 * @Auth
			 * @Date 2021/12/1
			 */
			toggleTkFlag() {
				// 展示基站
				this.handleFilters.showTkFlag = !this.handleFilters.showTkFlag;
				
				// 清除 图元
				this.mapSub.clearAllTks('destroy');
				
				// 刷新地图图元 工具柜
				this.handleFilters.showTkFlag && this.refreshMapToolkits();
			},
			/**
			 * @Des 刷新地图图元 工具柜
			 * @Auth
			 * @Date 2021/12/1
			 */
			refreshMapToolkits() {
				
				// 展示工具柜
				if (!this.handleFilters.showTkFlag) return false;
				
				// 重新绘制
				this.toolkits.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row)) return true;
					row.index = index;
					
					// 空值 跳过
					if (this.$checkEmpty(row.mapIds) || this.$checkEmpty(row.pointXPx) || this.$checkEmpty(row.pointYPx)) {
						return false;
					}
					
					// 不在同一区域
					if (row.subsectionId != this.filters.areaId) return false;
					// 总览图 跳过
					if (this.$checkEmpty(this.filters.mapId)) return false;
					
					// mapId
					let mapIds = row.mapIds.split(',');
					// pointXPxs
					let pointXPxs = row.pointXPx.split(',');
					// pointYPxs
					let pointYPxs = row.pointYPx.split(',');
					
					let onIndex = mapIds.indexOf((this.filters.mapId).toString());
					// 地图不匹配 跳过
					if (onIndex == -1) return false;
					
					// 绘制 工具柜
					this.mapSub.loadTkPosition(Object.assign({}, row, {pointXPx: parseFloat(pointXPxs[onIndex]), pointYPx: parseFloat(pointYPxs[onIndex])}));
				});
			},
			
			// ======================================= 工具柜 end ============================================ \\
						
			// ======================================= 手动获取区域 点名 start ============================================ \\
			
			/**
			 * @Des 切换点名tab
			 * @Auth
			 * @Date 2021/11/17
			 */
			changeRollCallTab(onKey) {
				
				// 当前展示项 key
                this.rollCallFilters.onKey = onKey;
				
				var rollCallRows = Object.assign([], this.rollCallFilters[onKey]);//  [].concat(this.rollCallFilters[onKey]);
				// 当前展示项 list
            	this.rollCallFilters.onRows = Object.assign({}, rollCallRows);
            	
			},
			
			/**
			 * @Des 重置 点名列表
			 * @Auth
			 * @Date 2021/11/17
			 */
			initRollCallFilters() {
				
				// 是否展示信息框
                this.rollCallFilters.infoFlag = false;
            	// 点名区域
            	this.rollCallFilters.sceneScope = [];
            	// 当前展示项 list
            	this.rollCallFilters.onRows = [];
            	// 干警 list
            	this.rollCallFilters.polices = [];
            	// 犯人 list
            	this.rollCallFilters.prisoners = [];
            	// 工具 list
            	this.rollCallFilters.tools = [];
				
			},
			
			/**
			 * @Des 获取点名数据
			 * @Auth
			 * @Date 2021/11/17
			 */
			getRollCallData(_points) {
				
				// 点名区域
				this.rollCallFilters.sceneScope = _points.split(';');//'[]; // 多边形数据
				
				var rows = this.map_list_position.values();
				// 排序 人员编号
				rows.sort((a, b) => {
					
					var changeState = a.userNo > b.userNo ? 1 : -1;
					
					return changeState;
					
				});
				
				//人员 列表 police
				var userList_police = [];
				//人员 列表 prisoner
				var userList_prisoner = [];
				//人员 列表 police
				var toolList = [];
				// 遍历 定位数据
				rows.forEach((row, index) => {
					
					// 空值 跳过
					if (this.$checkEmpty(row)) return true;
					// 消失报警 跳过
					//if (row.alarmType == 12) return true;
					
					// 非本区域 跳过
            		if (row.areaId != this.filters.areaId) return true;
            		// 非本地图 跳过
            		if (!this.$checkEmpty(this.filters.mapId) && row.mapId != this.filters.mapId) return true;
					
					// 点是否在区域范围内 isPosIn: false--不在当前二级区域范围内； true--在当前区域（一级或二级）范围内
					var isPosIn = this.matchPosIn_rollCall([row.pixelX, row.pixelY]);
					if (!isPosIn) return true;
					
					// 记录信息
					var _row = {};
					_row.id = row.id;
					_row.name = row.name;
					_row.userNo = row.userNo;
					_row.isAlarmed = row.isAlarmed;
					_row.groupName = row.groupName;
					_row.userType = row.userType;
					
					if (row.userType == 10) {
						//工具 列表
						toolList.push(_row);
					} else if (row.userType == 5) {
						//人员 列表 police
						userList_police.push(_row);
					} else if (row.userType == 4) {
						//人员 列表 prisoner
						userList_prisoner.push(_row);
					}
					
				});
				// 干警 list
            	this.rollCallFilters.polices = userList_police;
            	// 犯人 list
            	this.rollCallFilters.prisoners = userList_prisoner;
            	// 工具 list
            	this.rollCallFilters.tools = toolList;
            	
				//人员 数量
				var num_rollCall = (userList_prisoner.length);
				
				//人员
				var userStr = '当前区域总数为 ' + num_rollCall;
				
				var msgItems = [];
				
				if(num_rollCall == 0) {
					// 是否展示信息框
					this.rollCallFilters.infoFlag = false;
				} else {
					// 是否展示信息框
					this.rollCallFilters.infoFlag = true;
				}
				
				//msgItems.push(userStr);
				//msgItems.push('干警数量：' + userList_police.length);
				msgItems.push('学员人数：' + userList_prisoner.length);
				//msgItems.push('工具数量：' + toolList.length);
				// 关闭信息弹窗
                this.$notify.closeAll();
				// 消息 通知
				this.$notify({
					title: '点名成功',
					message: msgItems.join('<br/>'),
					type: 'success',
					dangerouslyUseHTMLString: true,
				});
				
				// 人数 救援人员
				this.changeRollCallTab(this.rollCallFilters.onKey);
				
			},
			/**
			 * @Des 检索 点是否在多边形内部
			 * @Auth
			 * @Date 2021/11/17
			 */
			matchPosIn_rollCall(pointVal) {
				
				// 检查 参数 位置点是否为真值
				if(this.$checkEmpty(pointVal)) return false;
				// 检查 参数 多边形集合是否为真值
				if(this.$checkEmpty(this.rollCallFilters.sceneScope)) return true;
				
				var points = this.$checkEmpty(pointVal) ? [] : typeof pointVal == 'string' ? pointVal.split(',') : pointVal;
				
				// 任意多边形有N个顶点
				var nCount = this.rollCallFilters.sceneScope.length;
				var nCross = 0;
				
				// 遍历多边形顶点
				for(var i = 0; i < nCount; i++) {
					
					var pStart = this.rollCallFilters.sceneScope[i];
					var pEnd = this.rollCallFilters.sceneScope[(i + 1) % nCount];
					
					var pStarts = pStart.split(',');
					var pEnds = pEnd.split(',');
					
					var pStartY = parseInt(pStarts[1]);
					var pEndY = parseInt(pEnds[1]);
					
					// 相邻的两个点是平行于x轴的，肯定不相交，忽略
					if (pStartY == pEndY) continue;
					
					var pointY = parseInt(points[1]);
					var minPosY = Math.min(pStartY, pEndY);
					var maxPosY = Math.max(pStartY, pEndY);
					
					// 交点在pStart,pEnd的延长线上，pCur肯定不会与pStart.pEnd相交，忽略
					if ( pointY < minPosY || pointY > maxPosY ) continue;
					
					// 求当前点和x轴的平行线与pStart,pEnd直线的交点的x坐标
					var pointX = parseInt(points[0]);
					var pStartX = parseInt(pStarts[0]);
					var pEndX = parseInt(pEnds[0]);
					
					var x = (pointY - pStartY) * (pEndX - pStartX) / (pEndY - pStartY) + pStartX;
					
					// 若x坐标大于当前点的坐标，则有交点
			   		if (x >= pointX) nCross++;
					
				}
				
				// 单边交点为偶数，点在多边形之外
				return (nCross % 2 == 1);
				
			},
			
			/**
			 * @Des 开始自定义点名
			 * @Auth
			 * @Date 2021/11/17
			 */
			startRollCall() {
				
				// 重置 点名列表
				this.initRollCallFilters();
				
				// 滑动 获取区域
				this.mapSub.setFingerArea((data) => {
					
					// 获取点名数据
					this.getRollCallData(data);
					
				});
				
			},
			/**
			 * @Des 结束自定义点名
			 * @Auth
			 * @Date 2021/11/17
			 */
			endRollCall() {
				
				// 重置 点名列表
				this.initRollCallFilters();
				
				// 禁止滑动获取区域
				this.mapSub.stopFingerArea();
				
			},
			
			/**
			 * @Des 切换点名状态
			 * @Auth
			 * @Date 2021/11/17
			 */
			toggleRollCall() {
				
				// 操作按钮
                this.handleFilters.rollCallFlag = !this.handleFilters.rollCallFlag;
                
                if (this.handleFilters.rollCallFlag) {
                	// 开始自定义点名
                	this.startRollCall();
                } else {
                	// 结束自定义点名
                	this.endRollCall();
                }
				
			},
			/**
			 * @Des 关闭信息面板 点名
			 * @Auth
			 * @Date 2021/11/17
			 */
			closeRollCallInfo () {
				// 是否展示信息框
                this.rollCallFilters.infoFlag = false;
			},

//============================================ 手动获取区域 点名 end ====================================== \\
			
			/**
			 * @Des 进入实时页面
			 * @Auth
			 * @Date 
			 */
			toggleIntoReal() {
				// 跳转到 首页
				this.$router.replace({path: '/manager/location/monitor'}, ()=>{}, ()=>{});
			},// toggleIntoReal
			
			/**
			 * @Des 更新数据 报警类型
			 * @Auth
			 * @Date 
			 */
			flushAlarmFlushStates(data) {
				// 报警类型
				this.alarmStates = !this.$checkEmpty(data) ? Object.assign({}, data) : {};
			},
			/**
			 * @Des 更新数据 报警开关
			 * @Auth
			 * @Date 
			 */
			flushAlarmFlushStateSwitchs(data) {
				// 报警开关
				this.alarmStateSwitchs = !this.$checkEmpty(data) ? Object.assign({}, data) : {};
				// 刷新 列表
				this.flushListData();
				// 刷新全部 位置
				this.flushMapPositions();
			},
			/**
			 * @Des 更新数据 定位有效时间
			 * @Auth
			 * @Date 
			 */
			flushDisappearTime(data) {
				return false;
				
				// 清除计时器
				if (this.timer_autoDisappear) {
					clearTimeout(this.timer_autoDisappear);
					this.timer_autoDisappear = null;
				}
				
				// 定位有效时间
				this.disappearTime = data;
				
				// 空值 中止
				if (this.$checkEmpty(this.disappearTime)) return false;
				
				// 自动移除图元
				this.autoDisappearPosi();
			},
			/**
			 * @Des 自动移除图元
			 * @Auth
			 * @Date 
			 */
			autoDisappearPosi() {
				return false;
				
				// 清除计时器
				if (this.timer_autoDisappear) {
					clearTimeout(this.timer_autoDisappear);
					this.timer_autoDisappear = null;
				}
				
				// 空值 中止
				if (this.$checkEmpty(this.disappearTime)) return false;
				// 地图空值 中止
				if (this.$checkEmpty(this.filters.mapId)) return false;
				
				// 定位有效时间
				let disappearTime = parseFloat(this.disappearTime) * 1000;
				
				// 当前时间
				let timeL = new Date().getTime();
				
				let spliceFlag = false;
				// 当前地图设备
				const _posiKs = this.map_people_position_list.get(this.filters.mapId);
				const _alarmKs = this.map_people_alarm_list.get(this.filters.mapId);
				let posiKs = !this.$checkEmpty(_posiKs) && !this.$checkEmpty(_posiKs.list) ? _posiKs.list : [];
				let alarmKs = !this.$checkEmpty(_alarmKs) && !this.$checkEmpty(_alarmKs.list) ? _alarmKs.list : [];
				let rows = Object.assign([], [].concat(posiKs).concat(alarmKs));
				// 遍历 当前地图设备
				rows.forEach((key, index) => {
					// 当前地图 位置信息
					let posiData = this.map_list_position.get(key);
					// 空值 跳过
					if (this.$checkEmpty(posiData) || (posiData.isAlarmed == 0 && (timeL - posiData.time) >= disappearTime)) {
						// 从当前地图清除
						
						// 取消追踪
						this.trackPeo(key, false);
						// 视频追踪 取消
						this.cancelVideoTrack(key);
						
						// 清除人员
						this.mapSub.clearPeoplePosition(key);
						
						// 缓存 人员信息 移除
						if (this.map_list_position.containsKey(key)) {
							this.map_list_position.remove(key);
						};
						
						if (!spliceFlag) {
							spliceFlag = true;
						}
					}
				});
				
				// 当前已展示
				let posiValues = this.map_list_position.values();
				posiValues = !this.$checkEmpty(posiValues) ? posiValues : [];
				// 遍历 当前地图设备
				Object.assign([], posiValues).forEach((row, index) => {
					let key = row.tagId;
					
					// 空值 跳过
					if (this.$checkEmpty(row) || (rows.indexOf(key) == -1) || (row.isAlarmed == 0 && (timeL - row.time) >= disappearTime)) {
						// 从当前地图清除
						
						// 取消追踪
						this.trackPeo(key, false);
						// 视频追踪 取消
						this.cancelVideoTrack(key);
						
						// 清除人员
						this.mapSub.clearPeoplePosition(key);
						
						// 缓存 人员信息 移除
						if (this.map_list_position.containsKey(key)) {
							this.map_list_position.remove(key);
						};
						
						if (!spliceFlag) {
							spliceFlag = true;
						}
					}
				});
				
				if (spliceFlag) {
					// 更新数据 列表数据
	    			this.flushListData();
	    			// 更新数据 地图位置
	    			this.flushMapPositions();
				}
				
				// 计时器 自动移除图元
				this.timer_autoDisappear = setTimeout(() => {
					// 自动移除图元
					this.autoDisappearPosi();
				}, disappearTime / 2);
			},
			/**
			 * @Des 更新数据 地图
			 * @Auth
			 * @Date 2021/8/6
			 */
            flushMaps(rows) {
            	// 清空 缓存
            	this.map_library.clear();
            	// 空值 中止
            	if (this.$checkEmpty(rows)) return false;
            	// 遍历
            	rows.forEach((row, index) => {
            		// 空值 跳过
            		if (this.$checkEmpty(row)) return false;
            		this.map_library.put(row.mapId, Object.assign({}, row));
            	});
            },
            /**
			 * @Des 更新数据 user
			 * @Auth
			 * @Date 2021/8/6
			 */
            flushTagUsers(rows) {
            	// 清空 缓存
            	this.map_tag_user.clear();
            	// 空值 中止
            	if (this.$checkEmpty(rows)) return false;
            	// 遍历
            	rows.forEach((row, index) => {
            		// 空值 跳过
            		if (this.$checkEmpty(row)) return false;
            		this.map_tag_user.put(row.tagId, Object.assign({}, row));
            	});
            },
            /**
			 * @Des 更新数据 报警信息
			 * @Auth
			 * @Date 2021/8/6
			 */
            flushTagAlarms(rows) {
            	// 清空 缓存
            	this.map_tag_alarm.clear();
            	// 空值 中止
            	if (this.$checkEmpty(rows)) return false;
            	// 遍历
            	rows.forEach((row, index) => {
            		// 空值 跳过
            		if (this.$checkEmpty(row)) return false;
            		// 格式化 报警数据
            		let formatRow = this.formatAlarmInfo(row.list, row.tagId);
            		this.map_tag_alarm.put(row.tagId, Object.assign({}, row, {formatRow: formatRow}));
            	});
            },
            /**
			 * @Des 更新数据 位置信息
			 * @Auth
			 * @Date 2021/8/6
			 */
            flushTagPositions(rows) {
            	// 清空 缓存
            	this.map_tag_in_position.clear();
            	// 空值 中止
            	if (this.$checkEmpty(rows)) return false;
            	// 遍历
            	rows.forEach((row, index) => {
            		// 空值 跳过
            		if (this.$checkEmpty(row)) return false;
            		this.map_tag_in_position.put(row.tagId, Object.assign({}, row));
            	});
            },
            /**
			 * @Des 更新数据 定位列表
			 * @Auth
			 * @Date 2021/8/6
			 */
            flushPositionKsList(rows) {
            	// 清空 缓存
            	this.map_people_position_list.clear();
            	// 空值 中止
            	if (this.$checkEmpty(rows)) return false;
            	// 遍历
            	rows.forEach((row, index) => {
            		// 空值 跳过
            		if (this.$checkEmpty(row)) return false;
            		this.map_people_position_list.put(row.mapId, Object.assign({}, row));
            	});
            },
            /**
			 * @Des 更新数据 报警列表
			 * @Auth
			 * @Date 2021/8/6
			 */
            flushAlarmKsList(rows) {
            	// 清空 缓存
            	this.map_people_alarm_list.clear();
            	// 空值 中止
            	if (this.$checkEmpty(rows)) return false;
            	// 遍历
            	rows.forEach((row, index) => {
            		// 空值 跳过
            		if (this.$checkEmpty(row)) return false;
            		this.map_people_alarm_list.put(row.mapId, Object.assign({}, row));
            	});
            },
            
            /**
			 * @Des 更新数据 工具柜列表
			 * @Auth
			 * @Date 2021/12/1
			 */
            flushToolcabinetList(rows) {
            	
            	// 空值
            	if (this.$checkEmpty(rows)) {
            		rows = [];
            	};
            	
            	// 工具柜
            	this.toolkits = Object.assign([], rows);
            },
            
            /**
			 * @Des 更新数据 列表数据
			 * @Auth
			 * @Date 2021/8/6
			 */
            flushListData() {
            	//this.filters.mapId;
            	
            	// 人员
            	let users = [];
            	// 车辆
            	let cars = [];
            	// 工具
            	let tools = [];
            	
            	// 报警开关
				let alarmState_4 = Object.assign({}, this.alarmStateSwitchs[4]);
				let alarmState_4_flag = alarmState_4['show'] && alarmState_4['switch'];
            	
            	// 报警
            	const alarms = this.map_people_alarm_list.values();
            	// 定位
            	const positions =  this.map_people_position_list.values();
            	
            	let rows = Object.assign([], [...alarms, ...positions]);// [].concat(alarms).concat(positions);
            	// 遍历
            	rows.forEach((row, index) => {
            		// 非本区域 跳过
            		if (!this.$checkEmpty(row.areaId) && row.areaId != this.filters.areaId) return true;
            		// 非本地图 跳过
            		if (!this.$checkEmpty(this.filters.mapId) && row.mapId != this.filters.mapId) return true;
            		
            		const list = !this.$checkEmpty(row.list) ? row.list : [];
            		// 遍历
            		list.forEach((v, i) => {
            			
            			let tagId = v;
	            		// 人员信息
	            		let userData = this.map_tag_user.get(tagId);
	            		// 报警信息
	            		let alarmData = this.map_tag_alarm.get(tagId);
	            		
	            		// 空值
	            		if (this.$checkEmpty(userData)) {
	            			userData = {};
	            		}
	            		if (this.$checkEmpty(alarmData)) {
	            			alarmData = {formatRow: null, list: [], tagId: userData.tagId};
	            		}
	            		
	            		// 已绑定
	            		if (!this.$checkEmpty(userData)) {
            				
            				// 位置信息
		            		let _posiData_ = this.map_tag_in_position.get(userData.tagId);
	            			if (this.$checkEmpty(_posiData_)) {
	            				// 无定位 中止
	            				return true;
	            			}
	            				
	            			// 超时 非报警 跳过
            				if (alarmData.list.length == 0 && !alarmState_4_flag && _posiData_.status == 2) return true;
	            			
	            			// 工具
	            			if (userData.toolType == 10) {
			            		// posiData 数据
			            		let _posiData = Object.assign({}, _posiData_);
			            		let canPosition = (!this.$checkEmpty(_data.pixelX) && !this.$checkEmpty(_data.pixelY)) || (!this.$checkEmpty(_data.areaPixelX) && !this.$checkEmpty(_data.areaPixelY));
	            				tools.push(Object.assign({}, {mapId: row.mapId, tagId: userData.tagId, canPosition: canPosition}, {userData: userData, alarmData: alarmData}));
	            			} else {
	            				users.push(Object.assign({}, {mapId: row.mapId, tagId: userData.tagId}, {userData: userData, alarmData: alarmData}));
	            			}
	            		}
            			
            		});
            		
            	});
            	// 重新赋值
            	this.users = users;
            	this.cars = cars;
            	this.tools = tools;
            	
            	// 数据更新 userList
            	this.flushUserList();
            	
            	// 绑定人员数量
            	let bdUserNum = 0;
            	/*Object.assign([], this.map_tag_user.values()).forEach((row, index) => {
            		// 空值 跳过
            		if (this.$checkEmpty(row)) return true;
            		
            		if (!this.$checkEmpty(row.tagId)) {
            			// 绑定人员数量
            			bdUserNum++;
            		}
            	});*/
            	// 绑定人员数量
            	//this.bdUserNum = bdUserNum;
            	
            	// 报警设备list 人员
            	let alarmList_user = [];
            	// 报警设备list 工具
            	let alarmList_tool = [];
            	// 检索报警数量
            	alarms.forEach((row, index) => {
        			// 不在同一大区域 跳过
        			// 非本区域 跳过
            		if (!this.$checkEmpty(row.areaId) && row.areaId != this.filters.areaId) return true;
        			
        			if (this.$checkEmpty(this.filters.mapId) || row.mapId == this.filters.mapId) {
        				let aList = !this.$checkEmpty(row) && !this.$checkEmpty(row.list) ? row.list : [];
        				aList.forEach((r, i) => {
        					// 人员信息
        					let userData = this.map_tag_user.get(r);
        					// 已绑定
        					if (!this.$checkEmpty(userData)) {
		            			// 工具
		            			if (userData.toolType == 10) {
		            				alarmList_tool.push(r);
		            			} else {
		            				// 人员
		            				alarmList_user.push(r);
		            			}
		            		}
        				});
        			}
        		});
            	
            	// 报警数 人员
            	this.alarmNum_user = alarmList_user.length;
            	// 报警数 工具
            	this.alarmNum_tool = alarmList_tool.length;
            },
            /**
			 * @Des 更新 追踪记录rows
			 * @Auth
			 * @Date 2021/8/6
			 */
            flushTrackedRows() {
            	let rows = [];
            	// 遍历
            	this.map_list_trackPeo.values().forEach((row, index) => {
            		// 非本地图 跳过
            		if (row.mapId != this.filters.mapId) return true;
            		
            		let tagId = row.tagId;
            		// 人员信息
            		let userData = this.map_tag_user.get(tagId);
            		// 报警信息
            		let alarmData = this.map_tag_alarm.get(tagId);
            		// 位置信息
					let posiData = this.map_list_position.get(tagId);
					// 地图信息
					let mapData = this.map_list_maps.get(row.mapId);
            		
            		// 空值
            		if (this.$checkEmpty(userData)) {
            			userData = {};
            		}
            		if (this.$checkEmpty(posiData)) {
            			posiData = {};
            		}
            		if (this.$checkEmpty(alarmData)) {
            			alarmData = {formatRow: null, list: [], tagId: userData.tagId};
            		}
            		
            		// 已绑定
            		if (!this.$checkEmpty(userData)) {
            			rows.push(Object.assign({}, {mapId: row.mapId, tagId: userData.tagId}, {userData: userData, alarmData: alarmData, posiData: posiData, mapData: mapData}));
            		}
            	});
            	
            	// 记录 追踪row
            	this.trackedRows = rows;
            },
            
            /**
			 * @Des 更新数据 地图位置
			 * @Auth
			 * @Date 2021/8/6
			 */
            flushMapPositions() {
            	// 人员 + 工具
            	let bdList = Object.assign([], [...this.userList, ...this.tools]);// [].concat(this.users).concat(this.tools);
            	bdList.forEach((row, index) => {
            		// 加载 地图位置
            		
            		// 人员信息
            		let userData = Object.assign({}, row.userData);
            		// 位置信息
            		let posiData = this.map_tag_in_position.get(userData.tagId);
            		
            		// data 数据
            		let _data = Object.assign({}, userData, posiData);
            		if (
            			(!this.$checkEmpty(_data.pointX) && !this.$checkEmpty(_data.pointY)) || 
            			(!this.$checkEmpty(_data.tagX) && !this.$checkEmpty(_data.tagY))
            		) {
            			//接收数据
            			this.receiveData({data: _data});
            		}
            		
            	});
            	
            	// 自动追踪第一个
            	// this.bdUserNum == 1 && 
            	if (this.userList.length == this.users.length && this.users.length == 1 && this.users[0] && this.users[0].tagId) {
            		this.trackPeo(this.users[0].tagId, true);
            	}
            },
            /**
			 * @Des 计算报警信息title
			 * @Auth
			 * @Date 2021/8/6
			 */
            calAlarmsTit(alarmData) {
            	let alarms = ['报警信息：'];
            	let list = alarmData.list;
            	list.forEach((row, index) => {
            		alarms.push(row.alarmName +'  '+ this.$moment(row.time).format('YYYY-MM-DD HH:mm:ss'));
            	});
            	return alarms.join('\n');
            },
            
            /**
			 * @Des 格式化 报警数据
			 * @Auth
			 * @Date 2021/8/6
			 */
			formatAlarmInfo(stateList, tagId) {
				// 空值 中止
				if (this.$checkEmpty(stateList)) return null;
				
				// 记录
				var statusList = [];
				var alarmIds = [];
				var alarmNames = [];
				var alarmTimes = [];
				var alarmTimeLs = [];
				var alarmTypes = [];
				var voiceIsOpens = [];
				var canVideoIds = [];
				var _voiceIsOpen = false;
				
				// 遍历
				stateList.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row)) return true;
					
					var alarmId = row.id;
					var alarmName = row.alarmName;
					
					var time = '';
					if(this.$checkEmpty(row.time)) {
						time = '';
					} else {
						var _timeZone = !this.$checkEmpty(row.timeZone) ? row.timeZone : 8;
						time = this.$moment(row.time).format('YYYY-MM-DD HH:mm:ss');
					}
					var alarmTime = time;
					var alarmTimeL = row.time;
					
					var alarmType = row.code;
					var voiceIsOpen = row.voiceIsOpen;
					if (voiceIsOpen) {
						_voiceIsOpen = true;
					}
					
					statusList.push(row);
					alarmIds.push(alarmId);
					alarmNames.push(alarmName);
					alarmTimes.push(alarmTime);
					alarmTimeLs.push(alarmTimeL);
					alarmTypes.push(alarmType);
					voiceIsOpens.push(voiceIsOpen);
					
					// 可追踪
					var canVideoIndex = this.alarmTypes_track.indexOf(alarmType);
					canVideoIndex > -1 && canVideoIds.push(alarmId);
					
				});
				
				var alarmTypeNew = 0;
				this.alarmTypes_sort.forEach((typeObj, index) => {
					// 非真值 跳过
					if(this.$checkEmpty(typeObj)) return true;
					
					if(alarmTypeNew = 0 && alarmTypes.indexOf(typeObj.key) > -1) {
						
						alarmTypeNew = typeObj.key;
						return false;
						
					}
					
				});
				
				// 可视频追踪 ids
				((alarmTypeNew == 4 && this.videoState_4 === 'close') || statusList.length <= 0) && (canVideoIds = []);
				
				if(canVideoIds.length <= 0) {
					// 可追踪 ids 为空 移除新报警
					this.map_list_alarmNew.containsKey(tagId) && this.map_list_alarmNew.remove(tagId);
					// 移除 黑名单
					this.map_list_alarmBlack.containsKey(tagId) && this.map_list_alarmBlack.remove(tagId);
				} else {
					
					var trackObj = {};
					trackObj['id'] = tagId;
					trackObj['canVideoIds'] = canVideoIds;
					
					this.map_list_alarmNew.put(tagId, trackObj);
					
				}
				
				// 是否报警
				var isAlarmed = statusList.length > 0 ? 1 : 0;
				var isAdd = 0;
				
				var stateObj = {};
				// 更改缓存
				stateObj['statusList'] = Object.assign([], statusList);// [].concat(statusList);
				stateObj['isAlarmed'] = isAlarmed;
				stateObj['alarmType'] = alarmTypeNew;
				stateObj['alarmIds'] = alarmIds;
				stateObj['alarmNames'] = alarmNames;
				stateObj['alarmTypes'] = alarmTypes;
				stateObj['alarmTimes'] = alarmTimes;
				stateObj['alarmTimeLs'] = alarmTimeLs;
				stateObj['voiceIsOpens'] = voiceIsOpens;
				stateObj['id'] = tagId;
				stateObj['tagId'] = tagId;
				stateObj['canVideoIds'] = canVideoIds;
				stateObj['voiceIsOpen'] = _voiceIsOpen;
				
				// 可视频追踪
				var canVideo = canVideoIds.length > 0;
				// 报警 黑名单
				var blackObj = this.map_list_alarmBlack.get(tagId);
				
				var canVideoIds_black = !this.$checkEmpty(blackObj) && !this.$checkEmpty(blackObj.canVideoIds) ? blackObj.canVideoIds.join(',') : '';
				// !isVideoed && !isAllInBlack 或者 !canVideo || isAllInBlack 一起使用，杜绝了 canVideoIds_black == '' && canVideoIds.join(',') == ''的错误状态
				var isAllInBlack = canVideoIds_black.indexOf(canVideoIds.join(',')) > -1;
				
				stateObj['canRealVideo'] = canVideo && !isAllInBlack;
				
				return stateObj;
			},
			
			// 初始化 当前场景 人员信息
			initPosiData() {
				// 初始化 视频弹窗
				this.initVideoWind();
				
				// 清除图元 人员
				this.mapSub.clearAllPeoples('destroy');
				// 清除图元 人员信息
				this.mapSub.clearAllTxts('destroy');
				// 定位/报警数 初始化
				this.mapSub.initPeoleNum(0, 0);
				
				// 清除计时器
				if (this.timer_autoDisappear) {
					clearTimeout(this.timer_autoDisappear);
					this.timer_autoDisappear = null;
				}
				
				// 清空缓存
				this.map_list_position.clear();// 定位信息
				
				// 已视频追踪
				this.videoedIds = [];
				
				// 重置解析 以及 重置变量
				this.resetParsing();
				
				if(this.timer_parsin) clearTimeout(this.timer_parsin);
				// 重置绘图状态
				
				if(this.$checkEmpty(this.filters.areaId) && this.$checkEmpty(this.filters.mapId)){
					return false;
				};
				
				// 开启 消息订阅
            	this.startSubscribes();
            	// 发布消息 获取全部数据
            	this.$pubsub.publish('dataInfo', 'initAllDatas');
            	
                const time = new Date().getTime();
                const sign = Secret.md5(time + "{" + 2 + "}");
                
            	// 发布消息 地图连接
            	this.$pubsub.publish('sendPositionWs', {code: 2, areaId: this.filters.areaId, mapId: this.filters.mapId, time: time,sign: sign});
            	
            	// 播放器 发送数据 握手
            	this.changePlayerDate({code: 'linkstatus', data: new Date().getTime(), pageMarker: 'intime', msg: '握手'});
            	
            	// 初始化追踪项
				this.map_list_trackPeo.values().forEach((value, index) => {
					
					const time = new Date().getTime();
        			const sign = Secret.md5(time + "{" + 3 + "}");
					// 发送数据
					var argJson = {
						//duId: value.id
						tagId: value.id,
						openVideo: 1,
						code: 3,
						time: time,
						sign: sign
					};
					
					// 发布消息 追踪
					this.$pubsub.publish('sendPositionWs', argJson);
					
					// 记录 视频追踪id
					this.videoedIds.indexOf(value.id) == -1 && this.videoedIds.push(value.id);
					
				});
				
				// 缓存  可自动视频追踪 未发送
				this.map_list_videoed.values().forEach((value, index) => {
					
					// 已追踪 跳过
					if(this.videoedIds.indexOf(value.id) == -1) {
						
						const time = new Date().getTime();
                		const sign = Secret.md5(time + "{" + 3 + "}");
						// 发送数据
						var argJson = {
							tagId: value.id,
							openVideo: 1,
							code: 3,
							time: time,
							sign: sign
						};
						
						// 发布消息 视频追踪
						this.$pubsub.publish('sendPositionWs', argJson);
						
						// 记录 视频追踪id
						this.videoedIds.indexOf(value.id) == -1 && this.videoedIds.push(value.id);
						
					};
					
					// 移除缓存
					this.map_list_videoed.containsKey(value.id) && this.map_list_videoed.remove(value.id);
					
				});
				
				// 自动移除图元
				//this.autoDisappearPosi();
			},
			
			//接收数据
			receiveData(data) {
				
				// 解析通道关闭状态 不再接收数据
				if(this.channal_stopped) return false;
				
				var eData = data.data;
				
				var tagId = eData.tagId;
				
				// 设备id 非真值 中止
				if(this.$checkEmpty(tagId)) return false;
				
				// 存在于新报警缓存
				var isInAlarmN = this.map_list_alarmNew.containsKey(tagId);
				// 存在于报警缓存
				var isInAlarms = this.map_tag_alarm.containsKey(tagId);
				// 存在于位置缓存
				var isInPosi = this.map_list_position.containsKey(tagId);
				
				if(!isInPosi && !isInAlarmN && isInAlarms) {
					
					var alarmRow = this.map_tag_alarm.get(tagId);
					var alarmObj = !this.$checkEmpty(alarmRow) && !this.$checkEmpty(alarmRow.fomatRow) ? alarmRow.fomatRow : {canVideoIds: []};
					
					var canVideoIds = alarmObj.canVideoIds;
					
					if(canVideoIds.length > 0) {
						
						var trackObj = {};
						trackObj['id'] = tagId;
						trackObj['canVideoIds'] = canVideoIds;
						
						// 缓存
						this.map_list_alarmNew.put(tagId, trackObj);
						
					}
					
				}
				
				// 存储 key
				this.queueKeys.indexOf(tagId) == -1 && this.queueKeys.push(tagId);
				
				if(this.queueKeys.length <= this.fullNum_dChannal) {
					
					if (this.$checkEmpty(data)) {
						console.log(1983);
					}
					//解析数据 位置 位置 ws301
					this.wsPosiData(data);
					
				} else {
					
					// 记录 接受数据
					if(this.$checkEmpty(this.stack_cord[tagId])) {
						
						this.stack_cord[tagId] = [data];
						
					} else {
						
						this.stack_cord[tagId].push(data);
						
					}
					
					// 记录阻塞数量
					this.blockNum_cord++;
					
					if(!this.isDrawing) {
						
						if(this.timer_parsin) clearTimeout(this.timer_parsin);
						
						this.isDrawing = true;
						this.timer_parsin = setTimeout(() => {
							
							// 解析通道关闭状态 不再接收数据
							if(this.channal_stopped) return false;
							// 解析数据 已接收队列 ==> 解析通道
							this.parsingData();
							
						}, this.freshTime_draw);
						
					}
					
				}
				
			},
			
			// 解析数据 已接收队列 ==> 解析通道
			parsingData() {
				
				// 解析 计时器 清除
				if(this.timer_drStack) clearTimeout(this.timer_drStack);
				
				if(this.$checkEmpty(this.stack_cord)) return false;
				
				// 正在绘制
				this.isDrawing = true;
				
				// 通道 队列数
				this.channalNum_drawing = Math.ceil(this.queueKeys.length / this.fullNum_dChannal);
				
				// 模拟 数据下标
				var didIndex = 0;
				
				// 遍历已接收数据队列
				var map_cord = Object.assign({}, this.stack_cord);
				for(var key in map_cord){
					
					var rows = map_cord[key];
					
					// 解析通道关闭状态 不再接收数据
					if(this.channal_stopped) return false;
					
					// 非真值 跳过
					if(this.$checkEmpty(rows)) {
						// 模拟下标
						this.didIndex++;
						return true;
					}
					
					var key_dChannal = didIndex % this.channalNum_drawing;
					
					var lastIndex = rows.length - 1;
					
					// 赋值 解析通道
					if(this.$checkEmpty(this.stack_drawing[key_dChannal])) {
						
						this.stack_drawing[key_dChannal] = [rows[lastIndex]];
						
					} else {
						
						this.stack_drawing[key_dChannal].push(rows[lastIndex]);
						
					}
					
					// 拋点
					this.stack_cord[key].splice(0, lastIndex + 1);
					
					// 更改 阻塞值
					this.blockNum_cord -= (lastIndex + 1);
					
					// 模拟下标
					this.didIndex++;
					
				};
				
				// 解析通道关闭状态 不再接收数据
				if(this.channal_stopped) return false;
				
				// 模拟下标 key 解析通道
				this.drIndex = 0;
				// 解析队列 绘制图元
				this.handleDrStack();
				
			},
			
			// 解析队列 绘制图元
			handleDrStack() {
				// 计时器 清除
				if(this.timer_drStack) clearTimeout(this.timer_drStack);
				
				// 通道记录值
				var rows_drawing = this.stack_drawing[this.drIndex];
				var cord_rows_drawing = Object.assign([], rows_drawing);// [].concat(rows_drawing);
				
				// 解析 各通道
				!this.$checkEmpty(rows_drawing) && cord_rows_drawing.forEach((row, index) => {
					
					// 解析通道关闭状态 不再接收数据
					if(this.channal_stopped) return false;
					
					if (this.$checkEmpty(row)) {
						console.log(2111);
					}
					//解析数据 位置 位置 ws301
					this.wsPosiData(row);
					
					this.stack_drawing[this.drIndex].splice(0, 1);
					
				});
				
				this.drIndex++;
				
				// 解析通道关闭状态 不再接收数据
				if(this.channal_stopped) return false;
				
				if(this.drIndex == this.channalNum_drawing) {
					
					if(this.blockNum_cord > 0) {
						
						// 计时器 开启
						this.timer_drStack = setTimeout(() => {
							
							// 解析通道关闭状态 不再接收数据
							if(this.channal_stopped) return false;
							
							// 解析数据 已接收队列 ==> 解析通道
							this.parsingData();
							
						}, this.freshTime_draw);
						
					} else {
						
						// 正在绘制
						this.isDrawing = false;
						
					}
					
					return false;
					
				}
				
				// 计时器 开启
				this.timer_drStack = setTimeout(() => {
					
					// 解析通道关闭状态 不再接收数据
					if(this.channal_stopped) return false;
					
					this.handleDrStack();
					
				}, this.freshTime_draw);
				
			},
			
			// 重置解析 以及 重置变量
			resetParsing() {
				
				// 正在绘制
				this.isDrawing = true;
				// 解析状态 停止
				this.channal_stopped = true;
				
				// 解析入口 计时器 清除
				if(this.timer_parsin) clearTimeout(this.timer_parsin);
				// 解析出口 计时器 清除
				if(this.timer_drStack) clearTimeout(this.timer_drStack);
				
				// 模拟下标 key 解析通道
				this.drIndex = 0;
				
				// 变量 队列
				this.queueKeys = [];																	// 队列 设备keys
				this.blockNum_cord = 0;																// 阻塞数量 已接收
				this.stack_cord = {};																// 队列 接收数据
				this.stack_drawing = {};																// 队列 绘制图元
				this.channalNum_drawing = 1;															// 通道数量 绘制图元
				
				// 解析状态 停止
				this.channal_stopped = false;
				// 正在绘制
				this.isDrawing = false;
				
				//缓存 可播放声音
				this.map_list_canVoice.clear();
				
			},
			
			//解析数据 位置 位置 ws301
			wsPosiData(data) {
				var posiData = data.data;
				
				var tagId = posiData.tagId;
				// 非真值 中止
				if(this.$checkEmpty(posiData)) return false;
				// 非真值 中止
				if(this.$checkEmpty(tagId)) return false;
				
				var oldPosiData = this.map_list_position.get(tagId);
				if (!this.$checkEmpty(oldPosiData)) {
					// 在上一次数据时间之前 中止
					if (oldPosiData.updateTime - posiData.updateTime > 0) {
						return false;
					}
				}
				
				posiData['id'] = tagId;
				
				let mapObj = this.map_list_maps.get(this.filters.mapId);
				if (!this.$checkEmpty(mapObj) && !this.$checkEmpty(mapObj.appId) && posiData.appId != mapObj.appId) {
					posiData['appId'] = mapObj.appId;
				}
				
				//videoAddress:[{videoNumber: 1,videoAddr:""}]
				//var videoList = !this.$checkEmpty(posiData.videoAddress) ? posiData.videoAddress : !this.$checkEmpty(posiData.videoList) ? posiData.videoList : [];//[{videoNumber: 1,videoAddr:"rtsp://admin:z455152781@192.168.5.201:554/h264/ch1/main/av_stream"}];
				var videoList = !this.$checkEmpty(posiData.videoId) ? posiData.videoId.split(',') : [];
				
				// 人员信息
				var userData = this.map_tag_user.get(tagId);//sessionStorage.getItem('user_' + tagId);
				var isBinding = !this.$checkEmpty(userData);
				
				var userObj = isBinding ? userData : {};
				
				// 报警信息
				var alarmData = this.map_tag_alarm.get(tagId);
				var alarmObj = !this.$checkEmpty(alarmData) && !this.$checkEmpty(alarmData.formatRow) ? Object.assign({}, alarmData.formatRow) : {};
				
				// alarmTypes
				var alarmTypes = !this.$checkEmpty(alarmObj.alarmTypes) ? alarmObj.alarmTypes : [];
				var exitFlag_alarm = true;// 当前无报警
				alarmTypes.forEach((key, index) => {
					if (exitFlag_alarm && !this.$checkEmpty(key) && this.alarmStates.hasOwnProperty(key)) {
						exitFlag_alarm = false;
					}
				});
				
				// 报警开关
				let alarmState_4 = Object.assign({}, this.alarmStateSwitchs[4]);
				let remove_off_Flag = !(alarmState_4['show'] && alarmState_4['seitch']) && posiData.status == 2;
				
				if(isBinding && !(exitFlag_alarm && remove_off_Flag)) {
					// 已绑定
					
					var posiObj = {};
					
					posiObj['appId'] = posiData.appId;
					posiObj['id'] = tagId;
					posiObj['tagId'] = tagId;
					posiObj['areaId'] = posiData.areaId;
					posiObj['mapId'] = posiData.mapId;
					posiObj['bindingType'] = posiData.bindingType || posiData.typeId || posiData.toolType;
					posiObj['areaPixelX'] = posiData.areaPixelX;
					posiObj['areaPixelY'] = posiData.areaPixelY;
					posiObj['pixelX'] = (this.$checkEmpty(this.filters.mapId) && !this.$checkEmpty(posiData.areaPixelX) ? posiData.areaPixelX : posiData.pixelX);
					posiObj['pixelY'] = (this.$checkEmpty(this.filters.mapId) && !this.$checkEmpty(posiData.areaPixelY) ? posiData.areaPixelY : posiData.pixelY);
					posiObj['areaPointX'] = posiData.areaPointX;
					posiObj['areaPointY'] = posiData.areaPointY;
					posiObj['pointX'] = posiData.pointX;
					posiObj['pointY'] = posiData.pointY;
					posiObj['pointZ'] = posiData.pointZ;
					posiObj['updateTime'] = posiData.updateTime;
					posiObj['time'] = posiData.time;
					
					posiObj['isAlarmed'] = !this.$checkEmpty(alarmObj.isAlarmed) ? alarmObj.isAlarmed : 0;
					posiObj['alarmType'] = !this.$checkEmpty(alarmObj.alarmType) ? alarmObj.alarmType : 0;
					posiObj['alarmIds'] = !this.$checkEmpty(alarmObj.alarmIds) ? alarmObj.alarmIds : [];
					posiObj['alarmTypes'] = alarmTypes;
					posiObj['alarmNames'] = !this.$checkEmpty(alarmObj.alarmNames) ? alarmObj.alarmNames : [];
					posiObj['alarmTimes'] = !this.$checkEmpty(alarmObj.alarmTimes) ? alarmObj.alarmTimes : [];
					posiObj['alarmTimeLs'] = !this.$checkEmpty(alarmObj.alarmTimeLs) ? alarmObj.alarmTimeLs : [];
					posiObj['voiceIsOpens'] = !this.$checkEmpty(alarmObj.voiceIsOpens) ? alarmObj.voiceIsOpens : [];
					posiObj['canVideoIds'] = !this.$checkEmpty(alarmObj.canVideoIds) ? alarmObj.canVideoIds : [];
					posiObj['canRealVideo'] = alarmObj.canRealVideo;
					
					posiObj['userType'] = (!this.$checkEmpty(userObj.typeId) ? userObj.typeId : posiData.typeId) || userObj.toolType;
					posiObj['name'] = userObj.userName || userObj.toolName;
					posiObj['sex'] = userObj.sex;
					posiObj['groupName'] = userObj.groupName;
					posiObj['userNo'] = userObj.userNo || userObj.toolNum;
					posiObj['sid'] = userObj.tagId;
					posiObj['userId'] = userObj.userId || userObj.toolId;
					
					// 计算 与 start point 距离
					/*var distances = this.calDistance(posiData.pixelX, posiData.pixelY, posiData.mapId);
					posiObj['disStartX'] = distances.distanceX;
					posiObj['disStartY'] = distances.distanceY;
					posiObj['mapType'] = distances.mapType;*/
					
					// 视频
					posiObj['videoList'] = videoList;
					posiObj['videoId'] = posiData.videoId;
					posiObj['status'] = posiData.status;
					
					// 缓存 更新值
					if(this.map_list_trackPeo.containsKey(posiObj.id)) this.map_list_trackPeo.put(posiObj.id, posiObj);
					// 更新 追踪记录rows
					this.flushTrackedRows();
					
					// 自动切换
					var trackPeoNum = this.map_list_trackPeo.size();
					// 是否存在于追踪map
					var isInTrackedMap = this.map_list_trackPeo.containsKey(posiObj.id);
					
					var isTrackedOne = trackPeoNum == 1 && isInTrackedMap;//trackedIds.length == 1;
					var trackValues = this.map_list_trackPeo.values();
					if(isTrackedOne) {
						this.autoChangeScenes(trackValues[0]);
					}
					// 不在同一一级区域，中止
					var isIn_1st = this.$checkEmpty(posiObj.mapId) || this.filters.mapId == posiObj.mapId;
					// 是否在大区域
					var isInArea = this.$checkEmpty(this.filters.mapId) && this.filters.areaId == posiObj.areaId;
					
					if(!(isIn_1st || isInArea)) {
						
						// 发送 视频追踪状态
						this.map_list_position.containsKey(posiObj.id) && this.sendVideoState(posiObj.id, 4);
						// 移除 新报警
						this.map_list_alarmNew.containsKey(posiObj.id) && this.map_list_alarmNew.remove(posiObj.id);
						// 移除 黑名单
						this.map_list_alarmBlack.containsKey(posiObj.id) && this.map_list_alarmBlack.remove(posiObj.id);
						// 移除 未成功打开视频
						this.map_list_videoWill.containsKey(posiObj.id) && this.map_list_videoWill.remove(posiObj.id);
						
						// 清除人员
						this.mapSub.clearPeoplePosition(posiObj.id);
						
						// 缓存 人员信息 移除
						if (this.map_list_position.containsKey(posiObj.id)) {
							this.map_list_position.remove(posiObj.id);
						}
						
						return false;
						
					};
					
					// 点是否在区域范围内 isPosIn: false--不在当前二级区域范围内； true--在当前区域（一级或二级）范围内
					var isPosIn = this.matchPosIn([posiObj.pixelX, posiObj.pixelY]);
					if(!isPosIn) {
						
						// 发送 视频追踪状态
						this.map_list_position.containsKey(posiObj.id) && this.sendVideoState(posiObj.id, 4);
						// 移除 新报警
						this.map_list_alarmNew.containsKey(posiObj.id) && this.map_list_alarmNew.remove(posiObj.id);
						// 移除 黑名单
						this.map_list_alarmBlack.containsKey(posiObj.id) && this.map_list_alarmBlack.remove(posiObj.id);
						// 移除 未成功打开视频
						this.map_list_videoWill.containsKey(posiObj.id) && this.map_list_videoWill.remove(posiObj.id);
						
						// 清除人员
						this.mapSub.clearPeoplePosition(posiObj.id);
						
						// 缓存 人员信息 移除
						if (this.map_list_position.containsKey(posiObj.id)) {
							this.map_list_position.remove(posiObj.id);
						}
						
						return false;
						
					};
					
					// 当前报警状态，取消追踪状态
					if(posiObj['isAlarmed'] != 0) {
						
						// 初始化追踪状态 取消追踪图标 (非追踪)
						!isInTrackedMap && this.initTrackImgs(posiObj.id);
						
					}
					
					var blackObj = this.map_list_alarmBlack.get(posiObj.id);
					
					// 是否已被视频追踪
					var isVideoed = this.videoedIds.indexOf(posiObj.id) > -1;
					
					// 报警 黑名单
					//var blackObj = map_list_alarmBlack.get(tagId);
					var canVideoIds_black = !this.$checkEmpty(blackObj) && !this.$checkEmpty(blackObj.canVideoIds) ? blackObj.canVideoIds.join(',') : '';
					// 完全处于黑名单内
					var isAllInBlack = canVideoIds_black.indexOf(posiObj.canVideoIds.join(',')) > -1;
					
					//var canVideoTrack = isInTrackedMap || (!isAllInBlack && canVideo);
					
					// 可自动视频追踪 &&  尚未追踪
					var canRealVideo = posiObj.canRealVideo;
					// 是否存在于追踪map
					//var isInTrackedMap = map_list_trackPeo.containsKey(tagId);
					
					var currCanRealVideo = false;//canRealVideo && !isAllInBlack;
					// 展示/取消 视频追踪
					var canVideo = currCanRealVideo || isInTrackedMap;
					
					// 发送 视频追踪状态
					if(false && canRealVideo && !isAllInBlack && !isVideoed) {
						// !this.$checkEmpty(this.ws) && typeof this.ws.send == 'function'
						if(true) {
							
							// 发送 视频追踪状态
							this.sendVideoState(posiObj.id, 3);
							
						} else {
							
							var videoedObj = {};
							videoedObj['id'] = posiObj.id;
							videoedObj['openVideo'] = 1;
							videoedObj['code'] = 3;
							// 缓存  可自动视频追踪 未发送
							this.map_list_videoed.put(posiObj.id, videoedObj);
							
						}
						
					};
					
					// 展示
					if(videoList.length > 0 && canVideo) {
						this.showVideos(posiObj);
					};
					// 取消
					if(!canVideo || videoList.length <= 0) {
						this.cancelVideoTrack(posiObj.id);
					};
					
					// 加载人员 svg
					this.mapSub.loadUwbPeoplePosition(posiObj);
					
					// 追踪人员 回显
					isInTrackedMap && this.mapSub.trackPeople(posiObj.id);
					// 记录追踪id
					isInTrackedMap && (this.trackedIds.indexOf(posiObj.id) == -1) && this.trackedIds.push(posiObj.id);
					
					// 缓存 人员信息
					this.map_list_position.put(posiObj.id, posiObj);
					
				} else {
					// 未绑定
					
					// 发送 视频追踪状态
					this.map_list_position.containsKey(posiData.id) && this.sendVideoState(posiData.id, 4);
					// 移除 新报警
					this.map_list_alarmNew.containsKey(posiData.id) && this.map_list_alarmNew.remove(posiData.id);
					// 移除 黑名单
					this.map_list_alarmBlack.containsKey(posiData.id) && this.map_list_alarmBlack.remove(posiData.id);
					// 移除 未成功打开视频
					this.map_list_videoWill.containsKey(posiData.id) && this.map_list_videoWill.remove(posiData.id);
					// 清除人员
					this.mapSub.clearPeoplePosition(posiData.id);
					// 缓存 人员信息 移除
					if (this.map_list_position.containsKey(posiData.id)) {
						this.map_list_position.remove(posiData.id);
					}
					
					// 清除人员
					this.mapSub.clearPeoplePosition(posiData.id);
					// 缓存 人员信息 移除
					if (this.map_list_position.containsKey(posiData.id)) {
						this.map_list_position.remove(posiData.id);
					};
					
				}
				
			},
			
			// 检索 点是否在多边形内部
			matchPosIn(pointVal) {
				
				// 检查 参数 位置点是否为真值
				if(this.$checkEmpty(pointVal)) return false;
				// 检查 参数 多边形集合是否为真值
				if(this.$checkEmpty(this.sceneScope)) return true;
				
				var sceneScope = Object.assign([], this.sceneScope);// [].concat(this.sceneScope);
				var points = this.$checkEmpty(pointVal) ? [] : typeof pointVal == 'string' ? pointVal.split(',') : pointVal;
				
				// 任意多边形有N个顶点
				var nCount = sceneScope.length;
				var nCross = 0;
				
				// 遍历多边形顶点
				for(var i = 0; i < nCount; i++) {
					
					var pStart = sceneScope[i];
					var pEnd = sceneScope[(i + 1) % nCount];
					
					var pStarts = pStart.split(',');
					var pEnds = pEnd.split(',');
					
					var pStartY = parseInt(pStarts[1]);
					var pEndY = parseInt(pEnds[1]);
					
					// 相邻的两个点是平行于x轴的，肯定不相交，忽略
					if (pStartY == pEndY) continue;
					
					var pointY = parseInt(points[1]);
					var minPosY = Math.min(pStartY, pEndY);
					var maxPosY = Math.max(pStartY, pEndY);
					
					// 交点在pStart,pEnd的延长线上，pCur肯定不会与pStart.pEnd相交，忽略
					if ( pointY < minPosY || pointY > maxPosY ) continue;
					
					// 求当前点和x轴的平行线与pStart,pEnd直线的交点的x坐标
					var pointX = parseInt(points[0]);
					var pStartX = parseInt(pStarts[0]);
					var pEndX = parseInt(pEnds[0]);
					
					var x = (pointY - pStartY) * (pEndX - pStartX) / (pEndY - pStartY) + pStartX;
					
					// 若x坐标大于当前点的坐标，则有交点
			   		if (x >= pointX) nCross++;
					
				}
				
				// 单边交点为偶数，点在多边形之外
				return (nCross % 2 == 1);
				
			},
			
			/**
			 * 自动切换
			 */
			autoChangeScenes(posiObj, isMatchIn) {
				
				var posiAreaId = posiObj.areaId;
				var posiMapId = posiObj.mapId;
				
				// 是否在 当前区域下
				var isInArea = this.$checkEmpty(posiAreaId) || posiAreaId == this.filters.areaId;
				// 不在当前区域下，切换区域
				if(!isInArea) {
					// 目标区域
					let currAreaRow = this.map_list_areas.get(posiAreaId);
					if (!this.$checkEmpty(posiMapId) && this.filters.mapId != posiMapId) {
						this.filters.mapId = posiMapId;
					}
					// 切换区域
					this.changeArea(currAreaRow);
					return false;
					
				} else if (this.filters.mapId != posiMapId) {
					// 目标区域
					let currMapRow = this.map_list_maps.get(posiMapId);
					// 切换区域
					this.changeMap(currMapRow);
					return false;
				}
				
				// 点是否在区域范围内 isPosIn: false--不在当前二级区域范围内； true--在当前区域（一级或二级）范围内
				var isPosIn = isMatchIn != undefined ? isMatchIn : this.matchPosIn([posiObj.pixelX, posiObj.pixelY]);
				// 在当前区域内
				if(isPosIn) return false;
				
			},
			
			// 发送 视频追踪状态
			sendVideoState(tagId, trackCode) {
				// 只点击追踪时展示视频
				if(trackCode == 1) {
					// 记录 视频追踪id
					this.videoedIds.indexOf(tagId) == -1 && this.videoedIds.push(tagId);
				} else {
					// 移除 视频追踪id
					var cordIndex = this.videoedIds.indexOf(tagId);
					cordIndex > -1 && this.videoedIds.splice(cordIndex, 1);
				}
				
				const time = new Date().getTime();
               	const sign = Secret.md5(time + "{" + trackCode + "}");
				// 发送数据
				var argJson = {
						tagId: tagId,
						code: trackCode,
						openVideo: (trackCode == 3 ? 1 : 0),
						time: time,
						sign: sign,
				};
				// 发布消息 地图断连
				this.$pubsub.publish('sendPositionWs', argJson);
			},
			
			//============================================================ 追踪 start ============================================================
			// 追踪
			trackPeo(id, trackFlag) {
				var posiObj = this.map_list_position.get(id);
				
				// 已开启视频追踪
				var videoedIndex = this.videoedIds.indexOf(id);
				var isVideoed = videoedIndex > -1;
				
				if(!trackFlag) {
					// 原来为追踪状态
					
					// 报警状态
					var alarmObj = this.map_list_alarmNew.get(id);
					var canVideoIds = !this.$checkEmpty(alarmObj) && !this.$checkEmpty(alarmObj.canVideoIds) ? alarmObj.canVideoIds : [];
					
					// 可视频追踪
					var canVideo = false;//canVideoIds.length > 0;
					// 报警 黑名单
					var blackObj = this.map_list_alarmBlack.get(id);
					var canVideoIds_black = !this.$checkEmpty(blackObj) && !this.$checkEmpty(blackObj.canVideoIds) ? blackObj.canVideoIds.join(',') : '';
					
					var isAllInBlack = canVideoIds_black.indexOf(canVideoIds.join(',')) > -1;
					
					// 是否自动追踪
					var isAutoTrack = canVideo && !isAllInBlack;
					
					// 取消 视频追踪 (包含:取消 追踪图标)
					//!isAutoTrack && cancelVideoTrack(id);
					
					// 取消 追踪人员
					//!isAutoTrack && this.mapSub.clearTrack(id, 'destroy');
					
					const time = new Date().getTime();
               		const sign = Secret.md5(time + "{" + 4 + "}");
					// 发送数据
					var argJson = {
						//noDuId: id
						tagId: id,
						openVideo: 0,
						code: 4,
						time: time,
						sign: sign
					};
					var jsonStr_not = JSON.stringify(argJson);
					
					// 已开启视频追踪
					if(isVideoed) {
						
						//(!canVideo || isAllInBlack) && !this.$checkEmpty(this.ws) && this.ws.readyState == this.ws.OPEN && typeof this.ws.send == 'function' && this.ws.send(jsonStr_not);
						// 发布消息 视频追踪
						(!canVideo || isAllInBlack) && this.$pubsub.publish('sendPositionWs', argJson);
						// 记录 移除
						(!canVideo || isAllInBlack) && this.videoedIds.splice(videoedIndex, 1);
						
					}
					
					// 移除缓存
					if(this.map_list_trackPeo.containsKey(id)) this.map_list_trackPeo.remove(id);
					
					var trackIndex = this.trackedIds.indexOf(id);
					
					trackIndex > -1 && this.trackedIds.splice(trackIndex, 1);
					
					// 取消 追踪人员
					//isAutoTrack && this.mapSub.clearTrack(id, 'destroy');
					this.mapSub.clearTrack(id, 'destroy');
					
					this.cancelVideoTrack(id);
					
				} else {
					// 原来为非追踪状态
					
					// 已经追踪 中止
					// 缓存
					if (this.map_list_trackPeo.containsKey(id)) return false;
					
					posiObj = !this.$checkEmpty(posiObj) ? posiObj : {};
					
					// 确认追踪
					this.doTrackPeo(id);
					
					// 清除计时器
					if (this.timer_fold_mini != null) {
						clearInterval(this.timer_fold_mini);
						// 计时器 fold mini
						this.timer_fold_mini = null;
					}
					// 折叠面板 mini
					this.foldMIniFlag = true;
					// 计时器 fold mini
					this.timer_fold_mini = setTimeout(() => {
						// 折叠面板 mini
						this.foldMIniFlag = false;
					}, 500);
				}
				
				// 下拉框是否可用
				var trackPeoNum = this.map_list_trackPeo.size();
				var isTrackedOne = trackPeoNum == 1;// && trackedIds.length == 1;
				// 记录单人追踪状态
				this.filters.trackedOne = isTrackedOne;
				
				// 更新 追踪记录rows
				this.flushTrackedRows();
				
				// 自动切换
				if(!isTrackedOne) return false;
				var trackedValues = this.map_list_trackPeo.values();
				this.autoChangeScenes(trackedValues[0]);
				
			},
			
			// 确认追踪
			doTrackPeo(_eId) {
				
				var posiObj = Object.assign({}, this.map_list_position.get(_eId));
				
				// 已开启视频追踪
				var videoedIndex = this.videoedIds.indexOf(_eId);
				var isVideoed = videoedIndex > -1;
				
				// 取消其余追踪
				this.cancelOtherTrack();
				
				// 缓存
				this.map_list_trackPeo.put(_eId, posiObj);
				
				// 记录追踪id
				(this.trackedIds.indexOf(_eId) == -1) && this.trackedIds.push(_eId);
				
				// 追踪人员
				this.mapSub.trackPeople(_eId);
				
				const time = new Date().getTime();
               	const sign = Secret.md5(time + "{" + 3 + "}");
				// 发送数据
				var argJson = {
						//duId: _eId
						tagId: _eId,
						openVideo: 1,
						code: 3,
						time: time,
						sign: sign
				};
				var jsonStr = JSON.stringify(argJson);
				
				// 未开启视频追踪
				if(!isVideoed) {
					
					// 发布消息 视频追踪
					this.$pubsub.publish('sendPositionWs', argJson);
					// 记录 添加
					this.videoedIds.push(_eId);
					
				}
				
				// 展示视频追踪 (强制打开)
				!this.$checkEmpty(posiObj) && !this.$checkEmpty(posiObj.videoList) && this.showVideos(posiObj, true);
				
				//接收数据 视频队列
				//!this.$checkEmpty(posiObj) && reciveQTrackId(posiObj.id);
				
			},
			
			// 取消其余追踪
			cancelOtherTrack() {
				
				// -1  不做限制
				if(this.maxTrackNum <= 0) {
					return false;
				}
				
				// 未达到最大追踪数目 中止
				if((this.trackedIds.length + 1) <= this.maxTrackNum) {
					return false;
				}
				
				var cancelNum = (this.trackedIds.length + 1) - this.maxTrackNum;
				var _trackedIds = Object.assign([], this.trackedIds);// [].concat(this.trackedIds);
				// 遍历，取消追踪
				_trackedIds.forEach((_trackId, index) => {
					
					if(index >= cancelNum) return false;
					
					var posiObj = this.map_list_position.get(_trackId);
					
					// 已开启视频追踪
					var videoedIndex = this.videoedIds.indexOf(_trackId);
					var isVideoed = videoedIndex > -1;
					
					// 原来为追踪状态
					
					// 报警状态
					var alarmObj = this.map_list_alarmNew.get(_trackId);
					var canVideoIds = !this.$checkEmpty(alarmObj) && !this.$checkEmpty(alarmObj.canVideoIds) ? alarmObj.canVideoIds : [];
					
					// 可视频追踪
					var canVideo = false;// canVideoIds.length > 0;
					// 报警 黑名单
					var blackObj = this.map_list_alarmBlack.get(_trackId);
					var canVideoIds_black = !this.$checkEmpty(blackObj) && !this.$checkEmpty(blackObj.canVideoIds) ? blackObj.canVideoIds.join(',') : '';
					
					var isAllInBlack = canVideoIds_black.indexOf(canVideoIds.join(',')) > -1;
					
					// 是否自动追踪
					var isAutoTrack = canVideo && !isAllInBlack;
					
					// 取消 视频追踪 (包含:取消 追踪图标)
					//!isAutoTrack && cancelVideoTrack(_trackId);
					// 取消 追踪人员
					this.mapSub.clearTrack(_trackId, 'destroy');
					
					const time = new Date().getTime();
               		const sign = Secret.md5(time + "{" + 4 + "}");
					// 发送数据
					var argJson = {
						//noDuId: id
						tagId: _trackId,
						openVideo: 0,
						code: 4,
						time: time,
						sign: sign
					};
					var jsonStr_not = JSON.stringify(argJson);
					
					// 已开启视频追踪
					if(isVideoed) {
						
						//(!canVideo || isAllInBlack) && !this.$checkEmpty(this.ws) && typeof this.ws.send == 'function' && this.ws.send(jsonStr_not);
						// 发布消息 视频追踪
						(!canVideo || isAllInBlack) && this.$pubsub.publish('sendPositionWs', argJson);
						// 记录 移除
						(!canVideo || isAllInBlack) && this.videoedIds.splice(videoedIndex, 1);
						
						(!canVideo || isAllInBlack) && this.cancelVideoTrack(_trackId);
						
					}
					
					// 移除缓存
					if(this.map_list_trackPeo.containsKey(_trackId)) this.map_list_trackPeo.remove(_trackId);
					this.map_list_IDs.containsKey(_trackId) && this.map_list_IDs.remove(_trackId);
					// 已展示视频 个数
					this.vPlayNum--;
					
					var trackIndex = this.trackedIds.indexOf(_trackId);
					
					trackIndex > -1 && this.trackedIds.splice(trackIndex, 1);
					
					var indInCancel = this.cancelTids.indexOf(_trackId);
					// 记录自动移除的trackId
					indInCancel == -1 && this.cancelTids.push(_trackId);
					
					// 取消 追踪人员
					isAutoTrack && this.mapSub.clearTrack(_trackId, 'destroy');
					
				});
				
			},
			
			// 初始化 追踪数据
			initTrackData() {
				
				// 遍历 已打开视频追踪
				this.trackedIds.forEach((value, index) => {
					
					// 移除缓存 追踪map
					if(this.map_list_trackPeo.containsKey(value)) this.map_list_trackPeo.remove(value);
					
				});
				
				// 初始化追踪状态
				this.initTrackImgs();
				
				// 添加 黑名单
				var alarmNewRows = this.map_list_alarmNew.values();
				
				// 遍历
				alarmNewRows.forEach((row, index) => {
					
					// 缓存 黑名单
					this.map_list_alarmBlack.put(row.id, row);
					
					// 取消 追踪人员
					this.mapSub.clearTrack(row.id, 'destroy');
					
					// 发送 视频追踪状态
					this.sendVideoState(row.id, 4);
					
				});
				// 清除 缓存  新报警
				this.map_list_alarmNew.clear();
				
				// 更新 追踪记录rows
				this.flushTrackedRows();
			},
			
			// 初始化追踪状态
			initTrackImgs(eTrackedId) {
				
				if(this.$checkEmpty(eTrackedId)) {
					
					// 遍历 已打开视频追踪
					var corfTrackeds = Object.assign([], this.trackedIds);// [].concat(this.trackedIds);
					corfTrackeds.forEach((value, index) => {
						
						var trackIndex = this.trackedIds.indexOf(eTrackedId);
						
						// 移除追踪记录
						trackIndex > -1 && this.trackedIds.splice(trackIndex, 1);
						
						// 初始化 追踪按钮
						this.initTrackBtn(value, false);
						
						// 取消 追踪人员
						this.mapSub.clearTrack(value, 'destroy');
						
					});
					
					// 下拉框是否可用
					var trackPeoNum = this.map_list_trackPeo.size();
					var isTrackedOne = trackPeoNum == 1;// && corfTrackeds.length == 1;
					// 记录单人追踪状态
					this.filters.trackedOne = isTrackedOne;
					
					// 记录追踪id
					this.trackedIds = [];
					
					return false;
				}
				
				var trackIndex = this.trackedIds.indexOf(eTrackedId);
				
				if(trackIndex > -1){
					
					this.trackedIds.splice(trackIndex, 1);
					
					// 初始化 追踪按钮
					this.initTrackBtn(eTrackedId, false);
					
					// 取消 追踪人员
					this.mapSub.clearTrack(eTrackedId, 'destroy');
					
				};
				
			},
			
			/**
			 * 初始化 追踪按钮
			 * 
			 * trackId: 位置id
			 * isTracked: 追踪状态true
			 */
			initTrackBtn(trackId, isTracked) {
				
				// 发送数据
				var argJson = {};
				if(isTracked) {
					// 追踪 状态
					//argJson['duId'] = trackId;
					argJson['tagId'] = trackId;
					argJson['openVideo'] = 1;
					argJson['code'] = 3;
					
					// 记录 视频追踪id
					this.videoedIds.indexOf(trackId) == -1 && this.videoedIds.push(trackId);
					
					console.log('进行追踪  ' + trackId);
				} else {
					// 取消 追踪 状态
					//argJson['noDuId'] = trackId;
					argJson['tagId'] = trackId;
					argJson['openVideo'] = 0;
					argJson['code'] = 4;
					// 取消 视频追踪
					this.cancelVideoTrack(trackId);
					
					// 移除 视频追踪id
					var cordIndex = this.videoedIds.indexOf(trackId);
					cordIndex > -1 && this.videoedIds.splice(cordIndex, 1);
					
					console.log('不再追踪  ' + trackId);
				}
				
				const time = new Date().getTime();
				const sign = Secret.md5(time + "{" + argJson.cod + "}");
				
				argJson['time'] = time;
				argJson['sign'] = sign;
				var jsonStr = JSON.stringify(argJson);
				// 发布消息 ws交互
				this.$pubsub.publish('sendPositionWs', argJson);
				
			},
			//============================================================ 追踪 end ============================================================
			
			//============================================================ 视频 start ============================================================
			/**
			 * 参数option {...} 便于参数拓展
			 * ids 视频id 字符串 '1,2,3'
			 */
			showVideos(option, isRelink){
				// 禁止 视频
				if (this.disallowVideoFlag) return false;
				
				/*
				var $listCont_alarm = $('.listCont_alarm');
				var $rowItems = $listCont_alarm.find('.rowItem'),
					$hisvBtnLi_on = $rowItems.find('.hisvBtnLi.on');
				// 正在查看视频 中止
				if($hisvBtnLi_on.length > 0) return false;
				*/
				
				// 视频为空 不作处理
				if(this.$checkEmpty(option.videoList)) return false;
				
				// 不允许视频追踪 中止
				if(this.screenMode == 0) {
					
					if(this.$checkEmpty(this.layIndex_video) && this.infoWindow == null) {
						
						// 是否可进行取消操作
						this.canDoCancel = true;
						
					}
					
					// 关闭弹窗 layer
					//if(!this.$checkEmpty(layIndex_video)) layer.close(layIndex_video);
					this.layIndex_video = '';
					this.isOpend_video = false;
					
					//关闭分屏
					if(this.infoWindow != null) this.infoWindow.window.close();
					this.infoWindow = null;
					
					return false;
				};
				
				var trackId = option.id;
				var videoList = !this.$checkEmpty(option.videoList) ? Object.assign([], option.videoList) : [];
				var preVid = !this.$checkEmpty(option.preVid) ? option.preVid : '';
				var userName = !this.$checkEmpty(option.name) ? option.name : '----';
				var userNo = !this.$checkEmpty(option.userNo) ? option.userNo : '';
				var _vName = !this.$checkEmpty(userNo) ? (userName + '（'+ userNo +'）') : userName;
				
				// videoOption
				var _videoId = videoList[0];
				var _videoOption = this.map_list_cameras.get(_videoId);
				var videoOption = !this.$checkEmpty(_videoOption) ? Object.assign({}, _videoOption) : {};
				var preVids = !this.$checkEmpty(option.preVid) ? option.preVid.split(',') : ( videoList.length > 1 ? Object.assign([], videoList).splice(1, videoList.length - 1) : [] );
				
				var vOption = {trackId: trackId, vId: videoOption.number, preVid: preVid, name: _vName, videoList: videoList};
				
				// 已展示视频 trackId: vId;
				var openVidObj = this.map_list_IDs.get(trackId);
				openVidObj = !this.$checkEmpty(openVidObj) ? openVidObj : {};
				var isOpenThis = openVidObj.vId == videoOption.number && ( (!openVidObj.preVid && !preVid && (!!openVidObj.videoList && openVidObj.videoList.join(',') == videoList.join(','))) || (!!openVidObj.preVid && !!preVid && openVidObj.preVid == preVid) );
				// 视频是否已填充满
				var isVideoFill = this.vPlayNum >= this.maxVnum;
				// 是否已打开
				var isVideoedThis = this.map_list_IDs.containsKey(trackId);
				
				// 非重新打开 && (已打开 || 已占满) 中止
				if(!isRelink && (isOpenThis || (isVideoFill && !isVideoedThis))) return false;
				
				// 分屏
				if(this.screenMode == 2) {
					
					// 关闭弹窗 layer
					//if(!this.$checkEmpty(this.layIndex_video)) layer.close(this.layIndex_video);
					
					if(this.infoWindow == null) {
			
						//打开新窗口
						this.openNewWindow(this.video_list_page, 'newFile', this.fulls, vOption);
						
					} else {
						
						// 切换视频
						typeof this.infoWindow.changeTrackVideo == 'function' && this.infoWindow.changeTrackVideo(vOption);
						// 缓存 视频 延迟打开
						typeof this.infoWindow.changeTrackVideo != 'function' && this.map_list_videoWill.put(trackId, vOption);
						
					}
					
					return false;
				}
				
				//关闭分屏
				if(this.infoWindow != null) this.infoWindow.window.close();
				this.infoWindow = null;
				
				// 已打开视频层
				var isOpend = this.isOpend_video;
				
				if(isOpend) {
					// 已打开视频页
					
					var url = videoOption.realAddr;
					// 空值中止
					if(GlobalVariable.VIDEO_PLAYER_MODE == 1 && this.$checkEmpty(url)) return false;
					
					// 预加载项
					//var preVids = !this.$checkEmpty(preVid) ? preVid.split(',') : [];
					var preurl = [];
					var preList = [];
					preVids.forEach((v, i) => {
						
						// 空值中止
						if(this.$checkEmpty(v)) return true;
						
						var _vObj = this.map_list_cameras.get(v);
						// 空值中止
						if(this.$checkEmpty(_vObj)) return true;
						preList.push(Object.assign({}, _vObj, {vId: _vObj.number,rtsp: _vObj.realAddr}));
						
						var _url = _vObj.url;
						// 空值中止
						if(this.$checkEmpty(_url)) return true;
						preurl.push(_url);
						
					});
					
					var _vOption = {
							title: vOption.name,
							trackId: vOption.trackId,
							vId: videoOption.number,
							status: 1,
							url: url,
							preurl: preurl
					};
					// Webrtc Player
					if (GlobalVariable.VIDEO_PLAYER_MODE == 2) {
						_vOption['title'] = videoOption.diskChannelName;
						_vOption['vInfo'] = Object.assign({}, videoOption, {vId: videoOption.number, rtsp: videoOption.realAddr});
						_vOption['preList'] = Object.assign([], preList);
						_vOption['videoList'] = Object.assign([], videoList);
					}
					
					//发送数据 视频状态
					this.sendVideoStatePlayer( _vOption,  101,  '打开视频');
					
				} else {
					// 未打开视频页
					
					this.openVideosPage(vOption);
					
				}
				
			},
			/**
			 * 打开弹出层 视频
			 * 
			 * @params vOption: {...} 视频参数，包含：trackId, videoRows, userName
			 */
			openVideosPage(vOption) {
				
				var videoList = Object.assign([], vOption.videoList);
				// 空值中止
				if(this.$checkEmpty(videoList)) return false;
				
				var vObj = Object.assign({}, this.map_list_cameras.get(videoList[0]));
				// 空值中止
				if(GlobalVariable.VIDEO_PLAYER_MODE == 2 && this.$checkEmpty(vObj)) return false;
				
				var url = vObj.realAddr;
				// 空值中止
				if(GlobalVariable.VIDEO_PLAYER_MODE == 1 && this.$checkEmpty(url)) return false;
				
				var preVid = vOption.preVid;
				// 预加载项
				// var preVids = !this.$checkEmpty(preVid) ? preVid.split(',') : [];
				var preVids = !this.$checkEmpty(vOption.preVid) ? vOption.preVid.split(',') : ( videoList.length > 1 ? Object.assign([], videoList).splice(1, videoList.length - 1) : [] );
				
				var preurl = [];
				var preList = [];
				preVids.forEach((v, i) => {
					
					var _vObj = this.map_list_cameras.get(v);
					// 空值中止
					if(this.$checkEmpty(_vObj)) return true;
					preList.push(Object.assign({}, _vObj, {vId: _vObj.number,rtsp: _vObj.realAddr}));
					
					var _url = _vObj.realAddr;
					// 空值中止
					if(this.$checkEmpty(_url)) return true;
					
					preurl.push(_url);
					
				});
				
				var _vOption = {
						title: vOption.name,
						trackId: vOption.trackId,
						vId: vObj.number,
						status: 1,
						url: url,
						preurl: preurl
				};
				
				// Webrtc Player
				if (GlobalVariable.VIDEO_PLAYER_MODE == 2) {
					_vOption['title'] = vObj.diskChannelName;
					_vOption['vInfo'] = Object.assign({}, vObj, {vId: vObj.number, rtsp: vObj.realAddr});
					_vOption['preList'] = Object.assign([], preList);
					_vOption['videoList'] = Object.assign([], videoList);
				}
				
				//发送数据 视频状态
				this.sendVideoStatePlayer( _vOption,  101,  '打开视频');
				
				this.isOpend_video = true;
				
			},
			
			// 取消 视频追踪
			cancelVideoTrack(trackId, isClose) {
				
				// 取消 追踪人员
				//this.mapSub.clearTrack(trackId, 'destroy');
				
				var index_videoedIds = this.videoedIds.indexOf(trackId);
				var trackIndex = this.trackedIds.indexOf(trackId);
				var isInTrackMap = this.map_list_trackPeo.containsKey(trackId);
				var isInIDSmap = this.map_list_IDs.containsKey(trackId);
				
				// 未打开 中止  // 已展示视频 trackId: vId;
				var isNoInVideo = index_videoedIds == -1 && trackIndex == -1 && !isInTrackMap && !isInIDSmap;
				
				var _ind = this.cancelTids.indexOf(trackId);
				_ind > -1 && this.cancelTids.splice(_ind, 1);
				
				//if(isNoInVideo && _ind == -1) return false;
				if(isNoInVideo && !isClose) return false;
				
				// 已打开视频层
				var isOpend = this.isOpend_video;
				
				if(isOpend) {
					// 已打开视频页
					
					var _vOption = {
							title: '',
							trackId: trackId,
							vId: '',
							status: 4,
							url: ''
					};
					//发送数据 视频状态
					this.sendVideoStatePlayer( _vOption,  101,  '关闭视频');
					
				}
				
				if(this.infoWindow != null) {
					// 取消追踪 视频
					typeof this.infoWindow.closeVideoTrack == 'function' && this.infoWindow.closeVideoTrack(trackId);
				}
				
				// 当前无视频追踪
				var trackPeoNum = this.map_list_trackPeo.size();// trackedIds.length <= 0
				
				if(trackPeoNum <= 0 && this.map_list_alarmNew.size() <= 0) {
					
					// 自动关闭 视频弹窗
					this.autoClViWind();
					
				}
				
			},
			
			// 初始化 视频弹窗
			initVideoWind() {
				
				// 重置开关状态
				this.canDoCancel = true;
				
				// 不在视频区域 信息提示  开关集合
				this.noneMsgFlags = {};
				
				// 自动切换
				var trackPeoNum = this.map_list_trackPeo.size();
				var isTrackedOne = trackPeoNum == 1;// && trackedIds.length == 1;
				
				// 遍历 已打开视频追踪
				var corfTrackeds = Object.assign([], this.trackedIds);// [].concat(this.trackedIds);
				corfTrackeds.forEach((value, index) => {
					
					var trackIndex = this.trackedIds.indexOf(value);
					
					// 移除追踪记录
					trackIndex > -1 && this.trackedIds.splice(trackIndex, 1);
					
					var isInTrackedMap = this.map_list_trackPeo.containsKey(value);
					// 取消 视频追踪
					!(isTrackedOne && isInTrackedMap) && this.cancelVideoTrack(value);
					
					// 取消 追踪人员
					this.mapSub.clearTrack(value, 'destroy');
					
				});
				
				// 下拉框是否可用
				var trackPeoNum = this.map_list_trackPeo.size();
				var isTrackedOne = trackPeoNum == 1;// && corfTrackeds.length == 1;
				// 记录单人追踪状态
				this.filters.trackedOne = isTrackedOne;
				
				// 记录追踪id
				this.trackedIds = [];
				
				// 清除 黑名单、记录
				this.map_list_alarmBlack.clear();
				// 取消报警视频
				var alarmNewRows = this.map_list_alarmNew.values();
				// 遍历
				alarmNewRows.forEach((row, index) => {
					
					// 清除 缓存  新报警
					this.map_list_alarmNew.containsKey(row.id) && this.map_list_alarmNew.remove(row.id);
					
					var isInTrackedMap = this.map_list_trackPeo.containsKey(row.id);
					// 取消 视频追踪
					!(isTrackedOne && isInTrackedMap) && this.cancelVideoTrack(row.id);
					
					// 取消 追踪人员
					this.mapSub.clearTrack(row.id, 'destroy');
					
				});
				// 清除 缓存  新报警
				this.map_list_alarmNew.clear();
				
				// 移除 缓存
				this.map_list_videoWill.clear();
				
				// 清除追踪图标
				this.mapSub.clearAllTracks('destroy');
				
			},
			
			// 自动关闭 视频弹窗
			autoClViWind() {
				
				// 正在关闭视频窗
				if(this.inClosing_layer) return false;
				
				// 重置开关状态
				this.canDoCancel = false;
				
				// 未打开弹窗
				if(this.$checkEmpty(this.layIndex_video) && this.infoWindow == null) {
					// 重置开关状态
					this.canDoCancel = true;
				}
				
				// 关闭弹窗 layer
				if(!this.$checkEmpty(this.layIndex_video)) {
					// 正在关闭视频窗
					this.inClosing_layer = true;
					//layer.close(layIndex_video);
					this.layIndex_video = '';
					this.isOpend_video = false;
				};
				
				//关闭分屏
				if(this.infoWindow != null) {
					// 正在关闭视频窗
					this.inClosing_layer = true;
					this.infoWindow.window.close();
					this.infoWindow = null;
					// 正在关闭视频窗
					this.inClosing_layer = false;
				};
				
				// 清除 黑名单、记录
				//map_list_alarmBlack.clear();
				
				// 移除 缓存
				this.map_list_videoWill.clear();
				
				// 清除追踪图标
				this.mapSub.clearAllTracks('destroy');
				
			},
			
			//==================== 视频 队列 start ============================ \\
			
			//解析队列 展示视频
			parsingQTrackIds() {
				
				//清除定时器
				if(!this.$checkEmpty(this.timer_show_video)) clearInterval(this.timer_show_video);
				
				this.timer_show_video = setInterval(() => {
					
					// 空值 终止解析
					if(this.$checkEmpty(this.queueTrackIds)) {
						//清除定时器
						if(!this.$checkEmpty(this.timer_show_video)) clearInterval(this.timer_show_video);
						this.timer_show_video = null;
						return false;
					}
					
					var trackId = this.queueTrackIds[0];
					
					//非空值
					if(!this.$checkEmpty(trackId)) {
						//位置信息
						var posiObj = this.map_list_position.get(trackId);
						// 打开视频
						this.showVideos(posiObj);
					}
					
					this.queueTrackIds.splice(0, 1);
					
				}, 1000);
				
			},
			//接收数据 视频队列
			reciveQTrackId(_trackId) {
				
				//空值中止
				if(this.$checkEmpty(_trackId)) return false;
				
				//队列数据量
				var queueNum = this.queueTrackIds.length;
				// 已展示视频 trackId: vId; 数目
				var videoedNum = this.map_list_IDs.size();
				
				//是否已打开
				var isVideoed = this.map_list_IDs.containsKey(_trackId);
				// 是否存在队列
				var indexIn = this.queueTrackIds.indexOf(_trackId);
				var isInQueue = indexIn > -1;
				
				//展示总数
				var willVideoedNum = queueNum + videoedNum;
				//重复存在
				if(isVideoed && isInQueue) {
					willVideoedNum -= 1;
				}
				
				//已展示视频 trackId: vId;
				var openVidObj = this.map_list_IDs.get(_trackId);
				openVidObj = !this.$checkEmpty(openVidObj) ? openVidObj : {};
				//即将打开视频
				var willVidObj = this.map_list_position.get(_trackId);
				//是否已打开
				var isOpenThis = openVidObj.vId == willVidObj.vId && openVidObj.preVid == willVidObj.preVid;
				
				//已经打开视频 中止
				if((isOpenThis || this.$checkEmpty(willVidObj.vId)) && isInQueue) {
					// 记录将要展示的trackId
					this.queueTrackIds.splice(indexIn, 1);
				}
				
				//空值 中止
				if(this.$checkEmpty(willVidObj.vId)) return false;
				
				//打开视频总量已达最高值 && 不在打开序列 则 中止
				if(willVideoedNum >= this.maxVnum && !isVideoed) return false;
				
				
				// 记录将要展示的trackId
				!isInQueue && this.queueTrackIds.push(_trackId);
				
				//解析队列 展示视频
				!this.$checkEmpty(this.queueTrackIds) && this.$checkEmpty(this.timer_show_video) && this.parsingQTrackIds();
				
			},
			
			//==================== 视频 队列 end ============================ \\
			//============================================================ 视频 end ============================================================
			
			//============================================================ sebSoket player start ============================================================
			/**
             * @Des 播放器 发送数据
             * @Auth
             * @Date 
             */
            changePlayerDate(data) {
            	// 禁止 视频
				if (this.disallowVideoFlag) return false;
				// 非 Webrtc Player 中止
				if (GlobalVariable.VIDEO_PLAYER_MODE != 2) return false;
            	
            	// 发布消息 视频播放器
            	this.$pubsub.publish('ChangePlayerDate', Object.assign({}, data));
            },
			/**
             * @Des 播放器 数据改变
             * @Auth
             * @Date 
             */
			playerOnmessage(data) {
				// 禁止 视频
				if (this.disallowVideoFlag) return false;
				// 非 Webrtc Player 中止
				if (GlobalVariable.VIDEO_PLAYER_MODE != 2) return false;
				
				let dataObj = Object.assign({}, data);
				if(dataObj.code == 300){
					console.log('WebrtcPlayer 连接成功...');
					// 是否 成功建立链接
					this.isConnected = true;
					// 清除已有计时器
					if(!this.$checkEmpty(this.timer_init_wsPlayer)) clearTimeout(this.timer_init_wsPlayer);
					
					// 发送最大展示量
					var jsonData = {
							code: 666,
							maxNum: this.maxVnum
					};
					var jsonStr = JSON.stringify(jsonData);
					
					// 播放器 发送数据
					this.changePlayerDate(jsonData);
					
					var _version = dataObj.version;
					//更新提示
					//changeUpdateTips(_version);
					
					// 打开已展示视频
					this.initVideoedItem();
					
				}
				
				// 关闭视频框
				if(dataObj.code == -1) {
					// 已展示视频 trackId: vId;
					this.map_list_IDs.clear();
					// 重置开关状态
					this.canDoCancel = true;
					// 关闭视频框 回调
					this.endAllVideos();
				}
				
				// 播放 状态
				if(dataObj.code == 111) {
					
					// 开始播放
					if(dataObj.data == 1) {
						this.layIndex_video = 1;
						this.isOpend_video = true;
						
						var trackId = dataObj.trackId,
							vId = dataObj.vId;
						var posiObj = Object.assign({}, this.map_list_position.get(trackId));
						var preVid = !this.$checkEmpty(posiObj.preVid) ? posiObj.preVid : '';
						
						if(!this.$checkEmpty(trackId) && this.vPlayNum <= this.maxVnum) {
							// 已展示视频 trackId: vId;
							this.map_list_IDs.put(trackId, {vId: vId,preVid: preVid, videoList: dataObj.videoList});
						}
					}
					
					// 暂停播放
					if(dataObj.data == 2) {
						
					}
					
					// 继续播放
					if(dataObj.data == 3) {
						
					}
					
					// 播放结束
					if(dataObj.data == 4) {
						//index_video_on++;
						// 当前一个视频播放完毕
						//finishedOneVideo();
						
						var trackId = dataObj.trackId;
						/*
						//关闭视频框 回调 单个
						endOneVideo(trackId);
						*/
						if(!this.$checkEmpty(trackId)) {
							// 已展示视频 trackId: vId;
							this.map_list_IDs.containsKey(trackId) && this.map_list_IDs.remove(trackId);
						}
						
						// 性能提示记录
						this.index_layer_cpuRam = null;
						
					}
					
					// 播放结束 点击关闭按钮
					if(dataObj.data == 5) {
						//index_video_on++;
						// 当前一个视频播放完毕
						//finishedOneVideo();
						
						var trackId = dataObj.trackId;
						
						//关闭视频框 回调 单个
						this.endOneVideo(trackId);
						
						if(!this.$checkEmpty(trackId)) {
							// 已展示视频 trackId: vId;
							this.map_list_IDs.containsKey(trackId) && this.map_list_IDs.remove(trackId);
						}
						
						// 性能提示记录
						this.index_layer_cpuRam = null;
						
					}
					
					// CPU RAM 占用率过高
					if(dataObj.data == 6) {
						if(this.$checkEmpty(this.index_layer_cpuRam)) {
							this.index_layer_cpuRam = this.$message({
		                        message: '您的电脑配置过低，不再增加视频追踪！',
		                        type: 'warning',
		                        showClose: true,
		                        dangerouslyUseHTMLString: true
		                    });
						}
					}
					
					var playNum = parseInt(dataObj.playNum);
					// 已展示视频 个数
					if(!this.$checkEmpty(playNum)) {
						this.vPlayNum = playNum;
					};
					
				}
				
				// 播放速度
				if(dataObj.code == 312) {
					var speed = dataObj.data;
					this.rate_video = this.$checkEmpty(speed) ? 1 : speed;
				}
			},// playerOnmessage
			
			/**
             * @Des 连接发生错误
             * @Auth
             * @Date 2021/8/6
             */
			wsOnerrorPlayer() {
				// 非 VLC Player 中止
				if (GlobalVariable.VIDEO_PLAYER_MODE != 1) return false;
				
				// 是否 成功建立链接
				this.isConnected = false;
			},
			/**
             * @Des 连接关闭
             * @Auth
             * @Date 2021/8/6
             */
			wsOnclosePlayer() {
				// 非 VLC Player 中止
				if (GlobalVariable.VIDEO_PLAYER_MODE != 1) return false;
				
				// 重置正在播放视频信息
				this.playingVideo = {};
				// 性能提示记录
				this.index_layer_cpuRam = null;
				
				// 是否 成功建立链接
				this.isConnected = false;
			},
			/**
             * @Des 数据推送
             * @Auth
             * @Date 2021/8/6
             */
			wsOnmessagePlayer(event) {
				// 非 VLC Player 中止
				if (GlobalVariable.VIDEO_PLAYER_MODE != 1) return false;
				
				var data = event.data;
				var dataObj = eval('(' + data + ')');
				
				if(dataObj.code == 300){
					console.log('player连接成功...');
					// 是否 成功建立链接
					this.isConnected = true;
					// 清除已有计时器
					if(!this.$checkEmpty(this.timer_init_wsPlayer)) clearTimeout(this.timer_init_wsPlayer);
					
					// 发送最大展示量
					var jsonData = {
							code: 666,
							maxNum: this.maxVnum
					};
					var jsonStr = JSON.stringify(jsonData);
					(this.palyerSub && typeof this.palyerSub.send == 'function') && this.palyerSub.send(jsonStr);
					
					var _version = dataObj.version;
					//更新提示
					//changeUpdateTips(_version);
					
					// 打开已展示视频
					this.initVideoedItem();
					
				}
				
				// 关闭视频框
				if(dataObj.code == -1) {
					// 已展示视频 trackId: vId;
					this.map_list_IDs.clear();
					// 重置开关状态
					this.canDoCancel = true;
					// 关闭视频框 回调
					this.endAllVideos();
				}
				
				// 播放 状态
				if(dataObj.code == 111) {
					
					// 开始播放
					if(dataObj.data == 1) {
						this.layIndex_video = 1;
						this.isOpend_video = true;
						
						var trackId = dataObj.trackId,
							vId = dataObj.vId;
						var posiObj = Object.assign({}, this.map_list_position.get(trackId));
						var preVid = !this.$checkEmpty(posiObj) ? posiObj.preVid : '';
						
						if(!this.$checkEmpty(trackId) && this.vPlayNum <= this.maxVnum) {
							// 已展示视频 trackId: vId;
							this.map_list_IDs.put(trackId, {vId: vId,preVid: preVid});
						}
					}
					
					// 暂停播放
					if(dataObj.data == 2) {
						
					}
					
					// 继续播放
					if(dataObj.data == 3) {
						
					}
					
					// 播放结束
					if(dataObj.data == 4) {
						//index_video_on++;
						// 当前一个视频播放完毕
						//finishedOneVideo();
						
						var trackId = dataObj.trackId;
						/*
						//关闭视频框 回调 单个
						endOneVideo(trackId);
						*/
						if(!this.$checkEmpty(trackId)) {
							// 已展示视频 trackId: vId;
							this.map_list_IDs.containsKey(trackId) && this.map_list_IDs.remove(trackId);
						}
						
						// 性能提示记录
						this.index_layer_cpuRam = null;
						
					}
					
					// 播放结束 点击关闭按钮
					if(dataObj.data == 5) {
						//index_video_on++;
						// 当前一个视频播放完毕
						//finishedOneVideo();
						
						var trackId = dataObj.trackId;
						
						//关闭视频框 回调 单个
						this.endOneVideo(trackId);
						
						if(!this.$checkEmpty(trackId)) {
							// 已展示视频 trackId: vId;
							this.map_list_IDs.containsKey(trackId) && this.map_list_IDs.remove(trackId);
						}
						
						// 性能提示记录
						this.index_layer_cpuRam = null;
						
					}
					
					// CPU RAM 占用率过高
					if(dataObj.data == 6) {
						if(this.$checkEmpty(this.index_layer_cpuRam)) {
							this.index_layer_cpuRam = this.$message({
		                        message: '您的电脑配置过低，不再增加视频追踪！',
		                        type: 'warning',
		                        showClose: true,
		                        dangerouslyUseHTMLString: true
		                    });
						}
					}
					
					var playNum = parseInt(dataObj.playNum);
					// 已展示视频 个数
					if(!this.$checkEmpty(playNum)) {
						this.vPlayNum = playNum;
					};
					
				}
				
				// 播放速度
				if(dataObj.code == 312) {
					var speed = dataObj.data;
					this.rate_video = this.$checkEmpty(speed) ? 1 : speed;
				}
				
			//	// 播放速度
			//	if(dataObj.code == 312) {
			//		var speed = dataObj.rate;
			//	}
				
				this.reconnectionsPlayer = 0;
			},
			
			/**
			 * 打开已展示视频
			 */
			initVideoedItem() {
				
				// 清除计时器
				if(!this.$checkEmpty(this.timer_videos_reopen)) clearInterval(this.timer_videos_reopen);
				this.index_videos_reopen = 0;
				
				// 已打开视频
				var list_ids = this.map_list_IDs.keySet();
				var _trackedIds = Object.assign([], this.trackedIds);// [].concat(this.trackedIds);
				var _videoedIds = Object.assign([], list_ids);// [].concat(list_ids);
				// 遍历，取并集
				_trackedIds.forEach((v, i) => {
					
					var inIndex = _videoedIds.indexOf(v);
					// 未存在，加入
					if(inIndex == -1) {
						_videoedIds.push(v);
					}
					
				});
				
				this.timer_videos_reopen = setInterval(() => {
					
					// 已重新打开完毕
					var isOpenedAll = this.index_videos_reopen >= _videoedIds.length;
					// 已重新打开完毕 || 不再增加视频追踪 关闭定时器
					if(isOpenedAll || !this.$checkEmpty(this.index_layer_cpuRam)) {
						// 清除计时器
						if(!this.$checkEmpty(this.timer_videos_reopen)) clearInterval(this.timer_videos_reopen);
						this.timer_videos_reopen = null;
						return false;
					}
					
					var trackId = _videoedIds[this.index_videos_reopen];
					// 提取定位数据
					var posiObj = this.map_list_position.get(trackId);
					posiObj = !this.$checkEmpty(posiObj) ? posiObj : {};
					
					// 空值，跳过
					if(this.$checkEmpty(trackId) || this.$checkEmpty(posiObj)) return true;
					var isRelink = true;
					// 打开视频
					this.showVideos(posiObj, isRelink);
					
					// 下标递增
					this.index_videos_reopen++;
					
				}, 1000);
				
				return false;
				// 遍历 ， 打开视频
				_videoedIds.forEach((trackId, i) => {
					
					// 空值，跳过
					if(this.$checkEmpty(trackId)) return true;
					// 提取定位数据
					var posiObj = this.map_list_position.get(trackId);
					// 空值，跳过
					if(this.$checkEmpty(posiObj)) return true;
					var isRelink = true;
					// 打开视频
					this.showVideos(posiObj, isRelink);
					
				});
				
			},
			
			//发送数据 视频状态
			sendVideoStatePlayer( _option,  _code,  _msg) {
				if(!this.isConnected) {
					return false;
				}
				
				var jsonData = {
						code: _code,
						data: {
							title: _option.title,
							trackId: _option.trackId,
							vId: _option.vId,
							vInfo: _option.vInfo,
							status: _option.status,
							url: _option.url,
							preurl: _option.preurl,
							preList: _option.preList,
							videoList: _option.videoList,
							cpu: this.cpuPercent,
							memory: this.ramPercent,
							username: ''
						},
						msg: _msg
				};
				if (GlobalVariable.VIDEO_PLAYER_MODE == 1) {
					// VLC Player
					var jsonStr = JSON.stringify(jsonData);
					(typeof this.palyerSub.send == 'function') && this.palyerSub.send(jsonStr);
				} else if (GlobalVariable.VIDEO_PLAYER_MODE == 2) {
					// Webrtc Player
					// 播放器 发送数据
					this.changePlayerDate(jsonData);
				}
				
			},
			
			//关闭视频框 回调
			endAllVideos() {
				
				this.layIndex_video = '';
				this.isOpend_video = false;
				
				// 初始化 追踪数据
				this.canDoCancel && this.initTrackData();
				
				// 重置开关状态
				this.canDoCancel = true;
				
				// 移除 缓存
				this.map_list_videoWill.clear();
				
				// 正在关闭视频窗
				this.inClosing_layer = false;
				
				// 已展示视频 个数
				this.vPlayNum = 0;
				
				// 不在视频区域 信息提示  开关集合
				this.noneMsgFlags = {};
				
			},
			// 关闭视频弹窗
			closeVideoWin() {
				// 视频 参数
				var _vOption = {
						title: '',
						status: 4,
						url: ''
				};
				//发送数据 视频状态
				this.sendVideoStatePlayer( _vOption,  101,  '关闭视频');
			},
			
			//关闭视频框 回调 单个
			endOneVideo(trackId) {
				
				// 初始化 取消追踪
				this.initTrackImgs(trackId);
				
				// 移除缓存 追踪map
				this.map_list_trackPeo.containsKey(trackId) && this.map_list_trackPeo.remove(trackId);
				
				if(this.map_list_alarmNew.containsKey(trackId)) {
					
					var alarmObj = this.map_list_alarmNew.get(trackId);
					
					// 清除 黑名单、记录
					this.map_list_alarmBlack.put(trackId, alarmObj);
					
					// 清除 缓存  新报警
					this.map_list_alarmNew.remove(trackId);
					
				}
				
				// 移除 缓存
				this.map_list_videoWill.containsKey(trackId) && this.map_list_videoWill.remove(trackId);
				
				// 更新 追踪记录rows
				this.flushTrackedRows();
				
			},
			//============================================================ sebSoket player end ============================================================
			
        },
        /**
         * @Des 数据计算
         * @Auth 
         * @Date 2021/9/27
         */
        computed: {
			/**
			 * @Des 检索 地图URL为空
			 * @Auth 
			 * @Date 
			 */
			mapsUrlEmpty() {
                let emptyFlag = true;
                // 遍历 大区域
                this.areas.forEach((row, index) => {
                	if (emptyFlag && !this.$checkEmpty(row.mapUrl)) {
                		emptyFlag = false;
                	}
                });
                if (!emptyFlag) return false;
                
	            return this.$checkEmpty(this.maps);
            },
            /**
			 * @Des 检索 区域地图URL为空
			 * @Auth 
			 * @Date 
			 */
            areaUrlEmpty() {
				// 检索 当前区域
	        	let currArea = this.map_list_areas.get(this.filters.areaId);
	            return this.$checkEmpty(currArea) || this.$checkEmpty(currArea.mapUrl);
			},
        },// computed
		
    }
</script>

/* CSS */
<style lang="scss" scoped>
	*{
        box-sizing: border-box;
    }
    .table-item-box {
        height: 100%;
        width: 100%;
        /*padding-left: 260px;*/
		padding: 0;
		
		transition: all 0.4s;
	    -moz-transition: all .4s;
	    /* Firefox 4 */
	    -webkit-transition: all .4s;
	    /* Safari å’Œ Chrome */
	    -o-transition: all .4s;
	    /* Opera */
    }
    .table-item-box.max-box{
    	padding-left: 0px;
    }
    
    .el-form-item{
        margin-bottom: 0px;
        margin-right: 0px;
    }
	
    /deep/ .el-input__inner{
        font-size: 8px;
        height: 30px;
        line-height: 30px;
        padding: 0 5px;
    }
    /deep/ .el-form-item__label {
		color: #e6e6e6;
	}
    
    .page-box {
    	height: 100%;
    	width: 100%;
    	padding-right: 502px;
    	position: relative;
    	
    	transition: all 0.4s;
	    -moz-transition: all .4s;
	    /* Firefox 4 */
	    -webkit-transition: all .4s;
	    /* Safari å’Œ Chrome */
	    -o-transition: all .4s;
	    /* Opera */
		
		* {
			transition: all 0.4s;
		    -moz-transition: all .4s;
		    /* Firefox 4 */
		    -webkit-transition: all .4s;
		    /* Safari å’Œ Chrome */
		    -o-transition: all .4s;
		    /* Opera */
		}
    	
    	&.no-items {
    		padding-right: 0px;
    		
    		.map-items-box,
    		.handle-btns-box,
    		.detail-track-item {
    			right: 15px;
    		}
    		
    		.items-box {
    			width: 0;
    			padding: 0;
    			opacity: 0;
    		}
    	}
    }
    .map-box {
    	height: 100%;
    	width: 100%;
    	background-color: rgba(3, 11, 24, 0.87);
    	border: 2px solid #234582;
    	overflow: hidden;
    	
    	.off {
    		display: none;
    	}
    }
    .none-map-item {
    	height: 100%;
    	width: 100%;
    	position: relative;
    	
    	img {
    		position: absolute;
    		top: 0;
    		bottom: 0;
    		left: 0;
    		right: 0;
    		margin: auto;
    	}
    }
    
    /*========================== switch start ==========================*/
	.switchStyle /deep/ .el-switch__label * {
        line-height: 1;
        font-size: 12px;
        display: inline-block;
    }
    .switchStyle /deep/ .el-switch__label {
        position: absolute;
        display: none;
        color: #fff;
    }
    /*关闭时文字位置设置*/
    .switchStyle /deep/ .el-switch__label--left {
        z-index: 9;
    }
    /* 调整关闭时文字的显示位子 */
    .switchStyle /deep/ .el-switch__label--left span{
        padding-left: 25px;
    }
    /*打开时文字位置设置*/
    .switchStyle /deep/ .el-switch__label--right {
        z-index: 9;
    }
    /* 调整打开时文字的显示位子 */
    .switchStyle /deep/ .el-switch__label--right span{
        padding-right: 20px;
    }
    /*显示文字*/
    .switchStyle /deep/ .el-switch__label.is-active {
        display: block;
    }
    /* 调整按钮的宽度 */
    /deep/ .switchStyle.el-switch .el-switch__core,
    .el-switch .el-switch__label {
        width: 60px !important;
    }
    /*========================== switch end ==========================*/
    
    /*==== items 列表 start ====*/
    .items-box {
    	height: 100%;
    	width: 504px;
    	overflow: hidden;
    	overflow-y: auto;
    	padding: 5px;
    	
    	background-color: #070F1F;
    	background-image: url('~@/static_dazzle/images/bgs/right-box-bg.png');
    	background-repeat: no-repeat;
    	background-size: 100% 100%;
    	border: 2px solid;
    	border-image: linear-gradient(90deg, #034B8D, #0A9AFB, #034687) 1 1;
    	
    	position: absolute;
    	top: 0;
    	bottom: 0;
    	right: 0;
    	margin: auto;
    	
    }
    
    .el-row {
		margin: 0px;
		padding: 0px;
		margin-bottom: 5px;
	}
	
	.grid-content {
		padding: 20px 20px 20px 100px;
    	background-size: 40px auto;
    	background-repeat: no-repeat;
    	background-position: 20px center;
	}
	
	/* 施工 */
	.icon-user-bg-2, .icon-user-bg-7 {
		background-image: url('~@/static_dazzle/images/bgs/icon-user-bg-7.png');
	}
	/* 管理、领导 */
	.icon-user-bg-3, .icon-user-bg-8 {
		background-image: url('~@/static_dazzle/images/bgs/icon-user-bg-8.png');
	}
	/* 访客 */
	.icon-user-bg-1, .icon-user-bg-9 {
		background-image: url('~@/static_dazzle/images/bgs/icon-user-bg-9.png');
	}
	/* 车辆  ---天车吊钩--- */
	.icon-user-bg-100 {
		/*background-image: url('~@/static_dazzle/images/bgs/hook.png');*/
		background-image: url('~@/static_dazzle/images/bgs/car.png');
		background-size: 80px auto;
		background-position: 8px center;
	}
	
	.item-title {
		white-space: nowrap;
	    overflow: hidden;
	    text-overflow: ellipsis;
	    display: block;
	}
	.item-btns-box {
		/*display: flex;*/
		justify-content: space-evenly;
		align-items: center;
		/*height: 30px;*/
		text-align: left;
		padding-top: 0px;
		font-size: 16px;
		line-height: 24px;
		
		width: min-content;
		height: 0;
		
		position: relative;
		top: -50px;
		
		i {
			cursor: pointer;
			border-radius: 4px;
			
			&:hover {
				border-color: #409eff;
				color: #fff;
			}
			&:before {
				margin-right: 2px;
				font-size: 12px;
			}
		}
	}
	/*==== items 列表 end ====*/
	
	/*==== 折叠面板 start ====*/
	/deep/ .el-collapse {
		height: 100%;
		border-bottom: none;
		overflow-y: hidden;
	}
	/deep/ .el-collapse-item {
		height: 80px;
		overflow: hidden;
	}
	/deep/ .el-collapse-item.is-active {
		height: calc(100% - 80px*0);
		/*height: calc(100% - 80px);*/
	}
	/deep/ .el-collapse-item__wrap {
		background-color: rgba(0,0,0,0);
		/*height: calc(100% - 80px*1);*/
		height: calc(100% - 80px);
		overflow-y: auto;
	}
	/deep/ .el-collapse-item__header {
		height: 80px;
	    padding-left: 50px;
	    line-height: 1;
	    background-color: rgba(7, 16, 32, 0.6);
	    color: #e6e6e6;
	    
	    &.is-active {
			border-bottom-color: #b4bad3;
		}
	    
	    .el-input__inner {height: 40px;line-height: 40px;}
	}
	/deep/ .el-collapse-item__arrow {
		margin: 0;
		position: absolute;
		left: 20px;
	}
	/deep/ .el-collapse-item__content {
	    color: #e6e6e6;
	    text-align: left;
	    padding-bottom: 0px;
	    /*font-size: 12px;*/
	}
	/deep/ .el-collapse-item__content section > div {
		/*border-bottom: 1px dashed #b4bad3;*/
		padding: 5px 0px;
	}
	/deep/ .el-collapse-item__content section > div:last-child {
		border-bottom: none;
		padding-bottom: 0px;
	}
	/deep/ .el-collapse-item__content .collapse-item-content {
		position: relative;
	}
	.collapse-item-content span {
		line-height: 30px;
		/*position: absolute;*/
		/*top: 5px;*/
	}
	.collapse-item-content p {
		line-height: 30px;
		padding-left: 130px;
		margin: 0;
		
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	/*==== 折叠面板 end ====*/
    
    /*======== 区域、地图 列表  start ========*/
	.area-items-box, .map-items-box {
		font-size: 8px;
		/*padding-top: 20px;*/
		position: absolute;
	    top: 10px;
	    left: 10px;
	    overflow: visible;
	    
	    ul {
	    	list-style: none;
		    padding: 5px;
		    margin: 0;
		    max-height: 400px;
		    background-color: #0e5ec0;
		    border: 1px solid #20a0ff;
			border-radius: 4px;
			overflow: hidden;
			overflow-y: auto;
		    
		    /* ==== 滚动条  ==== */
			&::-webkit-scrollbar {
				width: 5px;
				height: 5px;
				background-color: #343d81;
				border-radius: 2px;
			}
			/*定义滑块 内阴影+圆角*/
			&::-webkit-scrollbar-thumb {
				background-color: #5975af;
				border-radius: 2px;
			}
			/* ==== 滚动条  ==== */
			&::-moz-scrollbar {
				width: 5px;
				height: 5px;
				background-color: #343d81;
				border-radius: 2px;
			}
			/*定义滑块 内阴影+圆角*/
			&::-moz-scrollbar-thumb {
				background-color: #5975af;
				border-radius: 2px;
			}
		    
		    li {
		    	padding: 5px;
		    	cursor: pointer;
		    	border-radius: 2px;
		    	width: 80px;
		    	white-space: nowrap;
			    overflow: hidden;
			    text-overflow: ellipsis;
			    display: block;
			    border: 1px solid rgba(0,0,0,0);
		    	&:hover {
		    		border-color: #409eff;
		    	}
		    	&.on {
		    		background-color: #1b51a2;
		    		border-color: #409eff;
		    		color: #fff;
		    	}
		    }
	    }
	    
	    &.roll-call-on {
	    	
	    	ul {
	    		
	    		li {
	    			cursor: not-allowed;
	    		}
	    	}
	    }
   }
   
	.map-items-box {
		top: auto;
		bottom: 10px;
		left: auto;
		right: 544px;
	}
	/*======== 区域、地图 列表  end ========*/
	
	/* ============= 人员 详细信息 start ============= */
	.detail-track-item {
	    color: #e6e6e6;
	    text-align: left;
	    font-size: 16px;
		line-height: 30px;
		padding: 20px 40px;
		border-radius: 4px;
		
		width: 370px;
		border: 1px solid;
		border-image: linear-gradient(90deg, #015EEA, #00C0FA) 1 1;
		box-shadow: 7px 18px 20px 4px #000000, 0px 0px 76px 0px rgba(5,47,112,0.86);
		
		background-image: url('~@/static_dazzle/images/bgs/detail-track-bg.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
    	background-position: center;
		
		transition: all .4s;
		
		position: absolute;
	    top: 104px;
	    right: 15px;
	    z-index: 2;
	    
	    &.detail-has-portrait {
	    	
	    	padding-left: 160px;
	    	padding-right: 20px;
	    	width: 470px;
	    	
	    }/* detail-has-portrait */
		
	}/* detail-track-item */
	
	.detail-track-item .collapse-item-content {
		position: relative;
	}
	/* ============= 人员 详细信息 end ============= */
	
	/*======== 操作按钮 集合  start ========*/
	/deep/ .handle-btns-box {
		position: absolute;
	    top: 17px;
	    right: 544px;
	    z-index: 4;
	    font-size: 0;
	    
	    .el-button {
	    	color: #66b1ff;
	    	font-size: 16px;
	    	height: 36px;
	    	line-height: 34px;
	    	padding: 0px 10px;
	    	min-width: 36px;
	    	text-align: center;
	    	background: linear-gradient(0deg, #0a3068, #0a2645);
	    	border: 1px solid #1F63A3;
	    	border-radius: 23px;
	    	vertical-align: middle;
	    	
	    	&.on {
	    		background: linear-gradient(0deg, #123466, #095cb8);
	    		color: #50fcfc;
	    	}
	    	
	    	i {
                line-height: 34px;
                font-size: 18px;
                margin-right: 2px;
            }
            
	    }
	    
	}
	/*======== 操作按钮 集合  end ========*/
    
    /* ======================== 点名列表 start ====================== */
	.clearfix:after{visibility:hidden;display: block;font-size:0;content:" ";clear:both;height:0;}
	* html .clearfix{ zoom: 1; } /* IE6 */
	*:first-child+html .clearfix { zoom: 1; } /* IE7 */
	ul, li {list-style: none;padding: 0;margin: 0;}
	
	.quick-close {
		float: right;
		font-size: 12px;
		padding: 4px;
	    background-color: #0e5ec0;
	    cursor: pointer;
	    border-left: 2px solid #bdc0cf;
	    border-bottom: 2px solid #bdc0cf;
	    border-radius: 2px;
	    
	    transition: all .4s;
		-moz-transition: all .4s;
		/* Firefox 4 */
		-webkit-transition: all .4s;
		/* Safari 和 Chrome */
		-o-transition: all .4s;
		/* Opera */
	}
	.quick-close .iconfont {
		font-size: 12px;
		
		transition: all .4s;
		-moz-transition: all .4s;
		/* Firefox 4 */
		-webkit-transition: all .4s;
		/* Safari 和 Chrome */
		-o-transition: all .4s;
		/* Opera */
	}
	.quick-close:hover {
		/*background-color: #c9c5c5;*/
		background-color: #2587df;
	}
	.quick-close:hover .iconfont {
		color: #fff;
	}
	
	.quick-search{
	    margin-left: 20px;
	    margin-top: 4px;
	    margin-bottom: 4px;
	    border: solid 1px #e4eaef;
	    -webkit-border-radius: 4px;
	    -moz-border-radius: 4px;
	    border-radius: 4px;
	    overflow: hidden;
	    float: left;
	}
	.search-text{
	    display: inline-block;
	    position: relative;
	}
	
	.tab-tit{
	    display: inline-block;
	    height: 30px;
	    line-height: 30px;
	    font-size: 14px;
	    /*color: #fff;*/
	    color: #e3fcfd;
	    /*background-color: #1a9afd;*/
	    background-color: #3f51b5;
	}
	.tab-tit ul li{
	    position: relative;
	    width: 100px;
	    text-align: center;
	    float: left;
	}
	.tab-tit ul li:after{
	    content: '';
	    position: absolute;
	    right: 0;
	    top: 0;
	    bottom: 0;
	    width: 0;
	    height: 100%;
	    /*border-right: solid 1px #047ad5;*/
	    border-right: solid 1px #cadada;
	}
	.tab-tit ul li:last-child:after{
	    border: none;
	}
	
	.tab-cont{
	    font-size: 12px;
	    /*color: #333;*/
	    color: #d2d5cf;
	    max-height: 200px;
	    overflow-y: auto;
	}
	
	.tab-row1{
	    overflow: hidden;
	    border-bottom: solid 1px #e6eaf3;
	    
	    &:hover {
	    	background-color: #1b51a2;
	    }
	}
	.tab-row1:last-child{
	    border: none;
	}
	.tab-row1 ul li{
	    width: 100px;
	    height: 30px;
	    line-height: 30px;
	    text-align: center;
	    float: left;
	}
	
	.tab-cont{
		min-height: 60px;
		max-height: 180px;
	    overflow: auto;
	}
	
	.tab-row1 ul:after{
		content: '';
		height: 0;
		width: 0;
		opacity: 0;
		clear: both;
		display: block;
	}
	.tab-row1 ul li{
		height: auto;
		min-height: 30px;
	}
	
	/* 点名信息面板 */
	.list-box-rollCall {
		/*position: absolute;*/
		position: fixed;
	    top: 63px;
	    left: 10px;
	    /*background-color: #fff;*/
	    background-color: #0e5ec0;
	    
	    border: 2px solid #bdc0cf;
	    border-radius: 4px;
	    
	    font-size: 12px;
	}
	.list-box-rollCall .quick-search{
		margin-left: 5px;
		margin-right: 5px;
	}
	.list-box-rollCall .search-text{
		cursor: pointer;
	    float: left;
	    width: 145px;
	    box-sizing: border-box;
	    text-align: center;
		border: 1px solid #ccc;
	}
	.list-box-rollCall .search-text.on{
		/*background: #1e9fff;*/
		background: #409eff;
	    color: #fff;
	}
	/*  表头  */
	.list-box-rollCall .tab-tit{
		border: 1px solid #cadada;
		/*border: 1px solid #102766;*/
	}
	.list-box-rollCall .tab-tit ul li{
		width: 180px;
	}
	/*  列表  */
	.list-box-rollCall .tab-row1 ul li{
		width: 180px;
	}
	.list-box-rollCall .tab-row1 ul li.but-track{
		width: 90px;
	}
	/* ======================== 点名列表 end ====================== */
    
</style>



// WEBPACK FOOTER //
// src/components_pages/Location/InTimePosition.vue